<template>
  <div class="merchant">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-radio v-model="radio" label="条件查询" class="x-m-l-20 x-m-r-5" @change="fHeadRadioChange">条件查询</el-radio>
        <el-radio v-model="radio" label="区域查询" class="x-m-l-5 x-m-r-20" @change="fHeadRadioChange">区域查询</el-radio>
        <!-- <el-cascader
          size="medium"
          :options="sortOptions"
          v-model="searchSortVal"
          @change="fHeadSortChange"
          style="width: 160px"
          class="x-m-r-2 x-m-l-5"
        ></el-cascader> -->
        <el-cascader v-if="radio == '区域查询'" size="medium" :options="[
            { label: '商户', value: '商户' },
            { label: '代理商', value: '代理商' },
          ]" v-model="searchTypeVal" @change="fHeadTypeChange" style="width: 100px" class="x-m-r-2"></el-cascader>
        <el-cascader clearable v-if="radio == '区域查询'" size="medium" separator="-" placeholder="区域查询（可选）"
          :options="shMallAddressOptions" :props="{ checkStrictly: true }" @change="fHeadAddressChange"
          v-model="searchAddressVal" class="x-m-r-15"></el-cascader>
        <el-button size="medium" type="primary" @click="nowPage=1;init()" v-if="radio == '区域查询'" class="x-m-r-15">查询
        </el-button>
        <el-input v-if="radio == '条件查询'" placeholder="手机号 用户名 门店名 代理商" v-model="merInputVal" size="medium"
          style="width: 300px" class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>
          <!-- <template slot="append">搜索</template> -->
        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>
        <!-- <el-button size="medium" type="primary">区域查找</el-button> -->
        <!-- <el-button size="medium" type="danger">清空</el-button> -->
      </div>
      <div class="x-flex">
        <!-- <div class="x-m-l-10 buy-software"> -->
        <el-button v-if="
            bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
          " type="" size="medium" @click="fShowMchTotal">商户汇总</el-button>
        <el-button v-if="
            bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
          " size="medium" @click="fTest">链路测试</el-button>
        <el-button type="primary" size="medium" @click="buySoftware = !buySoftware">软件购买</el-button>
        <!-- </div> -->
        <el-button type="danger" size="medium" @click="fRegMerchant">注册商户</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center" ref="xTable1">
          <!-- @header-cell-click="fTablePhoneClick" -->
          <vxe-column field="RC" title="序号" width="50" fixed="left">
          </vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="item in tableJson"
            :key="item.id">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == item.sortType && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == item.sortType && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column v-if="
              bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
            " field="user_ip" title="服务器地址" width="130">
            <template #header>
              <div class="x-flex x-row-between w100p" @click="fHeadSort('user_ip', 'asc')">
                <span>服务器地址</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == 'user_ip' && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == 'user_ip' && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column v-if="
              bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
            " field="db_name" title="数据库名" width="220">
            <template #header>
              <div class="x-flex x-row-between w100p" @click="fHeadSort('db_name', 'asc')">
                <span>数据库名</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == 'db_name' && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == 'db_name' && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column fixed="right" title="操作" width="140" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="fModify(scope.row)" class="x-m-l-4" style="color: #2c8ff2">
                修改
              </el-button>
              <el-button type="text" size="mini" @click="fDisposeMall(scope.row)" style="color: #f56c6c">
                配置门店
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>

        <div class="x-flex" style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          <div class="x-flex x-p-r-10">
            <el-radio v-model="timeRadio" label="REG" class="x-m-l-20 x-m-r-5">注册时间</el-radio>
            <el-radio v-model="timeRadio" label="LOGIN" class="x-m-l-5 x-m-r-20">最后登录</el-radio>
            <el-date-picker v-if='timeRadio == "REG"' style="width: 400px;" v-model="time" size="small"
              type="datetimerange" @change="nowPage=1;init()" format='yyyy-MM-dd HH:mm:ss'
              value-format='yyyy-MM-dd HH:mm:ss' :clearable="false" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>

            <el-date-picker v-if='timeRadio == "LOGIN"' size="small" :clearable="false" @change="init"
              v-model="lastTime" type="date" placeholder="选择日期时间">
            </el-date-picker>
            </el-date-picker>

          </div>
          <div>
            共 {{ TP }} 页 {{ TR }} 条 <span class="u-m-l-20" @click="fExportDataEvent">导出</span>
          </div>
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" :page-size='50'
          @current-change="fCurrentChange" :current-page="nowPage"
          style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <!-- 软件购买 -->
    <!-- <el-dialog :visible.sync="buySoftware" width="500px" :show-close="false">
      <div class="dialog-title">软件购买</div>
      <div class="centent">
        <div
          :class="['buy', buyType == 'buy1' ? 'buy-active' : '']"
          @click="fBuyChoose('buy1')"
        >
          <div class="buy-title">单店购买</div>
          <div style="font-size: 14px">按门店计费，商户终身版</div>
          <div class="price">¥ 299</div>
          <el-button @click="fGoBuy('299')">立即购买</el-button>
        </div>
        <div
          :class="['buy', buyType == 'buy2' ? 'buy-active' : '']"
          @click="fBuyChoose('buy2')"
        >
          <div class="buy-title">包年</div>
          <div style="font-size: 14px">无限制注册商户</div>
          <div class="price">¥ 3980</div>
          <el-button @click="fGoBuy('3980')">立即购买</el-button>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog :visible.sync="buySoftware" width="350px" :close-on-click-modal="false">
      <div class="x-m-t-30 x-flex" style="flex-direction: column">
        <div class="x-font-16 x-m-t-10">商务热线</div>
        <div class="x-m-t-20 x-m-b-30 x-font-21 c-primary">400-862-5828</div>
        <div class="x-m-b-30">官方网址：https://www.sanmipos.com</div>
      </div>
    </el-dialog>
    <!-- 软件购买付款界面 -->
    <el-dialog :visible.sync="goBuyDialog" width="300px">
      <div class="x-flex" style="flex-direction: column">
        <div style="text-align: center" class="x-m-t-20 x-m-b-10">待支付</div>
        <div class="x-font-24 x-m-b-18" style="color: #f76062">
          ¥ {{ buySoftwareMoney }}
        </div>
        <div style="width: 150px; height: 150px; background-color: #808080"></div>
        <div class="x-m-t-15 x-m-b-20">支付宝扫一扫完成支付！</div>
      </div>
    </el-dialog>
    <!-- 支付成功 -->
    <el-dialog :visible.sync="buySuccess" width="270px">
      <div class="x-flex x-row-center x-m-t-40">
        <img src="../../src/assets/img/sucess.png" alt="支付成功" style="width: 150px" />
      </div>
      <div class="x-flex x-row-center x-font-20 x-m-b-50">支付成功</div>
    </el-dialog>
    <!-- 支付失败 -->
    <el-dialog :visible.sync="buyFail" width="270px">
      <div class="x-flex x-row-center x-m-t-40">
        <img src="../../src/assets/img/fail.png" alt="支付失败" style="width: 150px" />
      </div>
      <div class="x-flex x-row-center x-font-20 x-m-b-30">支付失败</div>
      <div class="x-w100 x-h40 x-bd x-bd-ra-5 x-flex x-row-center"
        style="margin: 0 auto 30px; border-color: #ff6700; color: #ff6700">
        重新支付
      </div>
      <!-- <el-button>重新支付</el-button> -->
    </el-dialog>
    <!-- 注册/修改 商户 -->
    <el-dialog :visible.sync="addMerchant" width="900px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="5vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600" v-if="merchantAddOrEdit == 'ADD'">
          增加商户
        </div>
        <div class="x-font-15 f600" v-if="merchantAddOrEdit == 'EDIT'">
          修改商户
        </div>
        <div class="x-flex">
          <!-- <el-button
            size="small"
            type="primary"
            v-if="merchantAddOrEdit == 'ADD'"
            >生成商户自助注册二维码</el-button
          > -->
          <div class="x-flex x-p-r-10" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
            <div class="x-w80">
              伙伴手机号
            </div>
            <el-input style="width: 120px;" size="small" v-model="shInfo.partnerPhone"></el-input>
          </div>
          <div class="x-flex x-p-r-10" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
            <div class="x-w80">
              服务器地址
            </div>
            <el-input style="width: 120px;" size="small" v-model="shInfo.mchSrvIp"></el-input>
          </div>
          <el-button v-if="merchantAddOrEdit == 'ADD'" type="primary" size="small" @click="fSelfReg">生成商户自助注册二维码
          </el-button>
          <el-button v-if="
              bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098' && merchantAddOrEdit == 'EDIT'
            " type="primary" size="small" @click="fDelMch">删除</el-button>
          <!-- <el-button type="primary" size="small" @click="fExecSqlFile">升级</el-button> -->
          <el-button v-if="merchantAddOrEdit == 'ADD'" type="danger" size="small" @click="fAddMerchant">保存</el-button>
          <el-button v-if="merchantAddOrEdit == 'EDIT'" type="danger" size="small" @click="fSaveMerchant">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <!-- 第一行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">软件版本</div>
          <el-cascader size="small" class="x-flex-1" :options="shEditionOptions" v-model="shInfo.shEdition"
            :value="shInfo.shEdition" @change="shEditionChange"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">手机号码</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shPhone" maxlength="11" type="number"
            :disabled="merchantAddOrEdit == 'EDIT'"></el-input>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">联系人名</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shLxName"></el-input>
        </el-col>
      </el-row>
      <!-- 第二行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">用户类型</div>
          <el-cascader size="small" class="x-flex-1" :options="shUserTypeOptions" v-model="shInfo.shUserType"
            @change="shUserTypeChange"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="16">
          <div class="x-w100 x-text-r x-p-r-15 must">门店名称</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shMallName"></el-input>
        </el-col>
      </el-row>
      <!-- 第三行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">所属行业</div>
          <el-cascader size="small" class="x-flex-1" :options="shIndustryOptions" v-model="shInfo.shIndustry"
            @change="shIndustryChange"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="16">
          <div class="x-w100 x-text-r x-p-r-15 must">主要经营</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shMainMarketing"></el-input>
        </el-col>
      </el-row>
      <!-- 第四行 -->
      <!-- <el-row class="x-m-t-15"> -->


      <!-- <el-col :span="7" :offset="1">
          <el-input
            size="small"
            class="address x-flex-1"
            v-model="shInfo.shMallAddress"
            disabled
          ></el-input>
        </el-col> -->
      <!-- </el-row> -->

      <!-- 第四行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">门店地址</div>
          <el-cascader size="small" separator="-" class="x-flex-1" :options="shMallAddressOptions"
            @change="shMallAddressChange" v-model="addr"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="16">
          <div class="x-w100 x-text-r x-p-r-15 must">详细地址</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shMallDetailAddress"></el-input>
        </el-col>
      </el-row>
      <!-- 第五行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098' ?18:24">
          <div class="x-w100 x-text-r x-p-r-15 must">主页网址</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shHomeUrl"></el-input>
        </el-col>
        <el-col class="x-flex" :span="6" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
          <div class="x-w120 x-text-r x-p-r-15 must">可用加盟门店</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.jm_mall_can_use_num"></el-input>
        </el-col>
      </el-row>

      <!-- 第六行 -->


      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="18">
          <div class="x-w100 x-text-r x-p-r-15">备注信息</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shRemarks"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center" style="height: 32px" :span="6">
          <el-checkbox v-model="shInfo.wsYn" :disabled="merchantAddOrEdit == 'EDIT'?false:true" class="x-m-l-15">消息通知提醒
          </el-checkbox>
        </el-col>
      </el-row>
      <!-- <el-row class="x-m-t-30" v-eles>
        <el-col class="x-flex" :span="24">
          <div class="x-w100 x-text-r x-p-r-15">备注信息</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shRemarks"></el-input>
        </el-col>
      </el-row> -->
      <!-- 第七行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="18">
          <div class="x-w100 x-text-r x-p-r-15">广告网址</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shAdUrl"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center" style="height: 32px" :span="6">
          <el-checkbox v-model="shInfo.shAdChoose" class="x-m-l-15">副屏广告统一管理</el-checkbox>
        </el-col>
      </el-row>
      <!-- 第八行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">自定模块</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shCustomModelName" placeholder="模块名称"></el-input>
        </el-col>
        <el-col :span="9" :offset="1">
          <el-input size="small" v-model="shInfo.shCustomModelUrl" class="x-flex-1" placeholder="模块网址"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center" style="height: 32px" :span="6">
          <el-checkbox v-model="shInfo.shCustomModelChoose" class="x-m-l-15">自定模块打开独立浏览</el-checkbox>
        </el-col>
      </el-row>
      <!-- 第九行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">全部费用</div>
          <el-input size="small" class="x-flex-5" placeholder="0.00" v-model="shInfo.shAllCost"
            :disabled="merchantAddOrEdit == 'EDIT'"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center x-font-12 x-p-l-20" style="height: 32px" :span="8">
          *门店年费合计，具体年费请到门店信息设置
        </el-col>
        <el-col class="x-flex x-col-center x-font-12 " style="height: 32px" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">支付笔数</div>
          <el-input size="small" class="x-flex-5" placeholder="0.00" v-model="shInfo.mustPayCount"></el-input>
        </el-col>
      </el-row>
      <!-- 第十行 -->
      <el-row class="x-m-t-15 ">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">可用电脑</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shCanUseComputed"></el-input>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">商城到期</div>
          <el-date-picker size="small" class="x-flex-1" v-model="shInfo.shShopMallExpice" type="date" placeholder="选择日期"
            :clearable="false" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">订货到期</div>
          <el-date-picker size="small" class="x-flex-1" v-model="shInfo.shOrderGoodsExpice" type="date"
            :clearable="false" placeholder="选择日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15 x-m-b-30">
        <el-col class="x-flex" :span="12">
          <div class="x-w100 x-text-r x-p-r-15">ORG_AK</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.org_ak">
            <el-button slot="append" @click="fCreatedAkSk('org_ak')">生成</el-button>
          </el-input>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w100 x-text-r x-p-r-15 ">ORG_SK</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.org_sk">
            <el-button slot="append" @click="fCreatedAkSk('org_sk')">生成</el-button>
          </el-input>
        </el-col>

      </el-row>
    </el-dialog>
    <!-- 配置门店 -->
    <el-dialog :visible.sync="mallDispose" width="900px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="10vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">门店信息</div>
        <div class="x-flex">
          <!-- <el-button size="mini" type="primary">新增</el-button> -->
          <el-button v-if="showQcSj" type="primary" size="small" @click="cancelAllDataDialog = true">清除所有数据</el-button>
          <el-button type="primary" size="small" @click="fResetMall">重置1001密码</el-button>
          <el-button type="danger" size="small" @click="fModifyOrAddMall({}, 'add')">增加连锁门店</el-button>
          <el-button type="info" size="small" @click="fColseMall">退出</el-button>
        </div>
      </div>
      <el-table :data="mallData" style="width: 100%; margin-left: 10px; height: 200px; overflow-y: auto">
        <el-table-column prop="mall_id" label="门店编码" width="90">
        </el-table-column>
        <el-table-column prop="mall_name" label="门店名称"> </el-table-column>
        <el-table-column prop="stop_time" label="到期时间"> </el-table-column>
        <el-table-column prop="fy_money" label="门店费用" width="90">
        </el-table-column>
        <el-table-column prop="zb_xf_yn" label="总部续费" width="90">
        </el-table-column>
        <el-table-column prop="state" label="状态" width="50">
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="fModifyOrAddMall(scope.row, 'modify')" class="x-m-l-4">
              修改
            </el-button>
            <el-button type="text" size="mini" @click="fGetDzjqList(scope.row)">
              电子价签
            </el-button>
            <el-button type="text" size="mini" @click="fPaymentDispose(scope.row)" style="color: #f56c6c">
              支付配置
            </el-button>

          </template>
        </el-table-column>
      </el-table>
      <div v-if="showKhdBbTs">
        <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">客户端版本推送</div>
        </div>
        <el-row>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w80 x-text-c">安卓版本</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.androidVer">
              <el-button slot="append" @click="fSubSrvRegOper('ANDROID_VER')">推送</el-button>
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w80  x-text-c">win版本</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.winVer">
              <el-button slot="append" @click="fSubSrvRegOper('WIN_VER')">推送</el-button>
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w80  x-text-c">强制升级</div>
            <el-select size="small" class="x-flex-1" v-model="mallInfo.forceUpdateYn" placeholder="请选择">
              <el-option v-for="item in forceUpdateOtion" :key="item.val" :label="item.name" :value="item.val">
              </el-option>
            </el-select>
            <div class="x-p-l-10">
              <el-button size="small" @click="fSubSrvRegOper('FORCE_UPDATE')">推送</el-button>
            </div>
          </el-col>
        </el-row>
        <div class="dialog-title x-flex  x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">调试日志 </div>
          <div class="x-p-l-14">{{downLoadUrl}}</div>
        </div>
        <el-row>
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w80  x-text-c">开启调试</div>
            <el-select style="width: 150px;margin-right: 10px;" size="small" v-model="logSet.logVer" placeholder="请选择">
              <el-option v-for="item in logOption" :key="item.val" :label="item.val" :value="item.val">
              </el-option>
            </el-select>
            <el-input size="small" class="x-flex-1" type="text" v-model="logSet.logMallId"
              placeholder="例:00010001,00010002">
              <el-button slot="append" @click="fMchRegEx({oper: 'SET_DEBUG'})">保存设置</el-button>
            </el-input>
          </el-col>


        </el-row>
        <el-row style="border-top: 1px solid #e6e6e6;" class="x-m-t-12">
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80 x-text-c">查看日志</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="logGet.logMallId" placeholder="例:00010001">
              <el-button slot="append" @click="fMchRegEx({oper: 'PUSH'})">获取日志</el-button>
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80  x-text-c">日志日期</div>
            <el-date-picker class="x-flex-1" v-model="logGet.logDate" type="date" size="small" placeholder="选择日期"
              value-format="yyyyMMdd" :clearable="false">
            </el-date-picker>
            <div class="x-p-l-10">
              <el-button size="small" @click="fMchRegEx({oper: 'DOWN_LOAD'})">下载</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
        <div class="x-font-15 f600">客户化参数</div>
      </div>
      <el-row>
        <el-col class="x-flex x-m-t-15" :span="12">
          <div class="x-w80  x-text-c">客户名称</div>
          <el-input size="small" class="x-flex-1" type="text" v-model="custom.custom_name">
          </el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15" :span="12">
          <div class="x-w80  x-text-c">请求地址</div>
          <el-input size="small" class="x-flex-1" type="text" v-model="custom.custom_url">
          </el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15" :span="12">
          <div class="x-w80  x-text-c">拓展信息</div>
          <el-input size="small" class="x-flex-1" type="text" v-model="custom.custom_ex">
          </el-input>
        </el-col>
        <el-col class="x-flex x-row-between x-m-t-15" :span="12">
          <!-- <div class="x-w80 "></div> -->
          <div style="line-height: 32px;" class="x-p-l-20 x-p-r-20">
            <el-checkbox v-model="custom.custom_yn" true-label='Y' false-label='N'>是否启用</el-checkbox>
          </div>
          <el-button size="small" @click="fMchRegEx({oper: 'SET_CUSTOM'})">保存</el-button>
        </el-col>
      </el-row>
      <!-- 内层对话框 -->
      <el-dialog width="800px" title="" :visible.sync="innerModifyMall" append-to-body class="add-dialog"
        :show-close="false" :close-on-click-modal="false">
        <div class="dialog-title x-flex x-row-betwee x-p-b-20">
          <div class="x-font-15 f600">{{ innerModifyMallTitle }}</div>
        </div>

        <el-row class="x-p-t-20 x-bd-top">
          <!-- <el-col class="x-flex" :span="24">
            <div class="x-w80 x-p-r-15">门店编码</div>
            <el-input
              size="small"
              class="x-flex-1"
              v-model="mallInfo.mallId"
            ></el-input>
          </el-col> -->
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w80 x-p-r-15">门店名称</div>
            <el-input size="small" class="x-flex-1" v-model="mallInfo.mallName"></el-input>
          </el-col>
          <!-- <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w80 x-p-r-15">收费方案</div>
            <el-radio-group v-model="mallInfo.sfFaRadio">
              <el-radio label="按存储收费">按存储收费</el-radio>
              <el-radio label="按功能收费">按功能收费</el-radio>
            </el-radio-group>
          </el-col> -->
          <el-col class="x-flex x-m-t-15" :span="24" v-if="mallInfo.sfFaRadio == '按功能收费'">
            <vxe-table border resizable highlight-hover-row height="200px" :data="mallXfData" align="center"
              ref="xTable1" style="width: 100%;">
              <vxe-column field="size_name" min-width='90px' title="功能模板"></vxe-column>
              <vxe-column field="num" min-width='120px' title="包年续费/元" :edit-render="{autofocus: '.el-input__inner'}">
                <template slot-scope="scope">
                  <div class="f600 c-cz">{{scope.row.num}}</div>
                </template>
                <template #edit="{ row ,rowIndex ,column}">
                  <div class='numInput'>
                    <el-input class='delInput' v-model="row.num" type="number" @change='fGetYfMoney'>
                    </el-input>
                  </div>
                </template>
              </vxe-column>
              <vxe-column field="pro_create_time" title="包年到期时间" min-width='160px'
                :edit-render="{autofocus: '.el-input__inner'}">
                <template #edit="{ row ,rowIndex ,column}">
                  <el-date-picker style='width:100%' v-model="row.pro_create_time" type="date" format='yyyy-MM-dd'
                    value-format='yyyy-MM-dd' placeholder="选择包年到期时间" :clearable='true'>
                  </el-date-picker>
                </template>
              </vxe-column>
              <vxe-column field="num" min-width='80px' title="终身买断/元" :edit-render="{autofocus: '.el-input__inner'}">
                <template slot-scope="scope">
                  <div class="f600 c-cz">{{scope.row.num}}</div>
                </template>
                <template #edit="{ row ,rowIndex ,column}">
                  <div class='numInput'>
                    <el-input class='delInput' v-model="row.num" type="number" @change='fGetYfMoney'>
                    </el-input>
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12" v-if="mallInfo.sfFaRadio != '按功能收费'">
            <div class="x-w80 x-p-r-15">门店年费</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.mallAnnualFee"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="11" :offset="1" v-if="mallInfo.sfFaRadio != '按功能收费'">
            <div class="x-w80 x-p-r-15">到期时间</div>
            <el-date-picker size="small" class="x-flex-1"
              :disabled="bykApi.global.fGetPlatform().partnerInfo.data.can_chg_time != 'Y'"
              v-model="mallInfo.expireTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12" v-if="mallInfo.sfFaRadio != '按功能收费'">
            <div class="x-w80 x-p-r-15">终身费用</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.mdMoney"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15 x-col-center" style="height: 32px" :span="11" :offset="1"
            v-if="mallInfo.sfFaRadio != '按功能收费'">
            <el-checkbox v-model="mallInfo.zb_renew">总部统一续费</el-checkbox>
          </el-col>
        </el-row>

        <div slot="footer" class="dialog-footer">
          <el-button type="info" size="mini" @click="fInnerClose">
            取消
          </el-button>
          <el-button type="danger" size="mini" v-if="modifyOrAddMallType == 'add'" @click="fAddMall">
            确认增加
          </el-button>
          <el-button type="danger" size="mini" v-if="modifyOrAddMallType == 'modify'" @click="fEditMall">
            确认修改
          </el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 支付配置 -->
    <el-dialog :visible.sync="paymentDispose" width="700px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @opened="paymentDisposeOpened" @close="fPaymentDisposeClose">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">支付绑定</div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fPaymentDisposeSave">保存</el-button>
          <el-button type="info" size="small" @click="fPaymentDisposeClose">关闭</el-button>
        </div>
      </div>
      <el-row class="x-flex">
        <el-col class="x-flex x-m-t-15 x-flex-1 x-m-r-30">
          <div class="x-w90 x-text-r x-p-r-15 must">支付方式</div>
          <el-cascader size="small" class="x-flex-1" :options="payWayOptions" v-model="paymentInfo.payWay"
            @change="fPayWayChange"></el-cascader>
        </el-col>
        <el-col class="x-flex-1 x-flex x-col-center x-m-t-15" style="height: 32px">
          <el-checkbox v-model="paymentInfo.payWayChoose">
            支付宝使用官方支付（可实时到账）
          </el-checkbox>
        </el-col>
      </el-row>
      <div class="x-flex">
        <el-row class="x-flex-1 x-m-r-30">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">老板姓名</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bossName"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">老板电话</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bossPhone"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90 x-text-r x-p-r-15">备注信息</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.payRemarks"></el-input>
          </el-col>
        </el-row>
        <div class="x-flex-1">
          <!-- <div id="qrcode" ref="qrCodeUrl"></div> -->
          <div class="x-m-l-20">
            <div class="x-font-15 x-m-b-10">说明：</div>
            <div class="x-font-13 x-m-b-3">1.商户需开通支付宝当面付</div>
            <div class="x-font-13">2.请将二维码发给商户，扫码并授权</div>
          </div>
          <el-button @click="fQRCodeEnlarge" size="small" type="primary" class="x-m-t-20 x-m-l-20">点击生成授权二维码</el-button>
        </div>
      </div>
      <el-row class="x-m-b-20">
        <el-col class="x-flex x-m-t-15 x-p-r-15" :span="12">
          <div class="x-w90 x-text-r x-p-r-15 must">服务商名</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.fwsName"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15 x-p-r-15" :span="12">
          <div class="x-w90 x-text-r x-p-r-15 must">联系电话</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.fwsPhone"></el-input>
        </el-col>
      </el-row>

      <!-- 中国银联 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '中国银联'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">中国银联绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.ylShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">支付秘钥</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.ylPaySecretKey"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">终端号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.ylPayMallId"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 平安银行 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '平安银行'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">平安银行绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.payhShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">注册号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.payhPaySecretKey"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 微邮付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '微邮付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">微邮付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.wyfShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">支付秘钥</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.wyfPaySecretKey"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 贝友PAY -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '贝友PAY'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">贝友PAY绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bykShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">支付秘钥</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bykPaySecretKey"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">门店编码</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bykMallId"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 尚米PAY -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '尚米PAY'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">尚米PAY绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">商户编码</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.smShCode"></el-input>
          </el-col>
          <!-- <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">支付秘钥</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.smPaySecretKey"></el-input>
          </el-col> -->
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">门店编码</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.smMallId"></el-input>
          </el-col>


        </el-row>
      </div>
      <!-- 随行付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '随行付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">随行付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">代理商orgId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.sxfDlsOrgId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.sxfShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15">门店编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.sxfMallCode"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 汇付斗拱 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '汇付斗拱'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">汇付斗拱绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">服务商号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hfdgAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hfdgAppMallId"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 阿里云支付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '阿里云支付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">阿里云支付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.aliAppId"></el-input>
          </el-col>
          <!-- <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.aliShId"></el-input>
          </el-col> -->
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">门店编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.aliMallId"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 付呗 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '付呗'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">付呗绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">门店 ID</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.fbMallId"></el-input>
            <el-button type="" size="small" class="x-m-l-10" @click="fSetFbWxH5Path">设置微信H5支付路径</el-button>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">付呗 AppId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.fbAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">AppSecret</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.fbAppSecret"></el-input>
          </el-col>
        </el-row>
      </div>

      <!-- 盒子 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '盒子'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">盒子绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编码</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hzShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">门店编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hzMallCode"></el-input>
          </el-col>
        </el-row>
      </div>

      <!-- 东之付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '东之付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">东之付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w110 x-text-r x-p-r-15 must">门店 ID</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.dzfMallId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w110 x-text-r x-p-r-15 must">东之付 AppId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.dzfAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w110 x-text-r x-p-r-15 must">AppSecret</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.dzfAppSecret"></el-input>
          </el-col>
        </el-row>
      </div>

      <!-- 德宏农行付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '德宏农行付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">德宏农行付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hdMallId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">终端号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hdAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">AppSecret</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hdAppSecret"></el-input>
          </el-col>
        </el-row>
      </div>

      <!-- 陕西信合 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '陕西信合'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">陕西信合绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.sxxhShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15">线下编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.sxxhOfflineCode"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 银商支付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '银商支付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">银商支付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">appId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.ysAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.ysAppSecret"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">终端号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.ysAppMallId"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 拉卡拉 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '拉卡拉'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">拉卡拉绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">appId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.lklAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.lklAppSecret"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">终端号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.lklAppMallId"></el-input>
          </el-col>

        </el-row>
      </div>
      <!-- 京东支付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '京东支付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">京东支付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">商户编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.jdzfShCode"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">店铺编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.jdzfMallId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">代理秘钥</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.jdzfMy"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 河马付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '河马付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">河马付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">appId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hmAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">subAppId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hmSubAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">storeNo</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.hmStoreNo"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 信联付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '信联付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">信联付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">appId</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.xlfAppId"></el-input>
          </el-col>

          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">appSercet</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.xlfAppSercet"></el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 其他支付 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20" v-if="paymentInfo.payWay == '其他支付'">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600">其他支付绑定参数</div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">支付名称</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.qtAppId"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">支付账号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.qtAppSecret"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-10" :span="24">
            <div class="x-w100 x-text-r x-p-r-15 must">门店编号</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.qtMallId"></el-input>
          </el-col>

        </el-row>
      </div>
      <div class="dialog-title" style="padding: 7px 10px;">
        <div class="x-font-15 f600" style="cursor: pointer;" @click="payShowMore = !payShowMore">更多</div>
      </div>
      <el-row v-if="payShowMore" class="x-m-b-15 x-m-t-10">
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">服务商编码</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.payOrgId" placeholder="支付机构下服务商编码"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">商户编码</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.payOrgMchId" placeholder="三方支付机构商户编码"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">微信子商户号</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.wxSubMchId" placeholder="微信子商户号"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">公众号appId</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.wxAppId" placeholder="微信公众号appid"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">小程序appId</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.wxMinAppId" placeholder="小程序appId"></el-input>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 二维码放大 -->
    <el-dialog title="" :visible.sync="QRCodeEnlargeDialog" width="635px" @opened="maxQRCodeOpened" top="8vh"
      :show-close="false">
      <div style="width: 635px; height: 600px">
        <div id="qrcodeMax" ref="qrCodeUrlMax"></div>
      </div>
    </el-dialog>
    <!-- 自助注册二维码弹框 -->
    <el-dialog title="" :visible.sync="selfRegDialog" width="900px" top="5vh" :show-close="false">
      <div class="x-flex x-row-between x-m-t-20 x-p-b-15 x-bd-bottom">
        <div class="left-line x-font-15 f600">生成商户注册二维码</div>
        <div class="x-flex">
          <el-button type="info" size="small" @click="selfRegDialog = false">关闭</el-button>
        </div>
      </div>
      <!-- <div v-if=" bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'" style="width: 860px; height: 565px; flex-direction: column" class="x-flex x-row-center x-col-center x-p-40">
        <img src="../../src/assets/img/QRCode.png" alt="" style="width: 300px; margin-top: 70px" />
        <div class="x-m-50">
          <div class="x-font-15 f600">流程说明：</div>
          <div class="x-m-t-10 x-m-b-5">
            1：扫描二维码，核对信息，点击生成二维码
          </div>
          <div>2：将生成的二维码发给商户,商户自行提交注册</div>
        </div>
      </div> -->
      <div style="width: 860px; height: 565px; flex-direction: column" class="x-flex x-row-center x-col-center x-p-40">
        <div id="selfQr" ref="selfQrUrlMax"></div>
        <div class="x-m-t-10 x-m-b-5 x-font-16">将生成的二维码发给商户,商户自行提交注册</div>
      </div>
    </el-dialog>
    <!-- 清除所有数据 -->
    <el-dialog title="" :visible.sync="cancelAllDataDialog" width="550px">
      <div style="color: #f62515">
        <div class="x-font-18 f600">确认清除所有门店所有数据？</div>
        <div class="x-flex x-col-start x-m-t-20 x-font-16 f600">
          <div>特别提示：</div>
          <div class="x-flex-1">
            <div>删除数据为物理删除，删除后无法找回原有的数据！！！</div>
            <div class="x-m-t-10">请谨慎操作，一切后果自行负责！！！</div>
          </div>
        </div>
      </div>
      <div class="x-m-t-20 x-font-16 f600" style="color: #242424 !important">
        门店名：{{ this.mallDisposeInfo.mall_name }} &nbsp;&nbsp;&nbsp;&nbsp;
        手机号：{{ this.mallDisposeInfo.user_phone }}
      </div>
      <div class="x-m-t-20 x-m-b-20">
        <el-radio v-model="cancelDataTypeIdx" label="1">
          删除业务数据
        </el-radio>
        <el-radio v-model="cancelDataTypeIdx" label="2">
          仅保留基本档案
        </el-radio>
        <el-radio v-model="cancelDataTypeIdx" label="3">
          删除全部数据
        </el-radio>
      </div>
      <div v-if="cancelDataTypeIdx == 1">
        <el-date-picker v-model="cancelDataTime" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 380px">
        </el-date-picker>
      </div>
      <div class="x-m-t-20 x-m-b-20">
        <el-input v-model="partnerPwd" placeholder="请输入合作伙伴密码" size="large" style="width: 380px" type="password">
        </el-input>
      </div>
      <div class="x-flex x-row-right">
        <el-button size="small" type="info" @click="cancelAllDataDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="fResetAllData">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 商户汇总 -->
    <el-dialog :visible.sync="mchTotalPop" width="400px" :close-on-click-modal="false">
      <div class="x-w100p x-text-c f600 x-font-16">商户汇总</div>
      <div class="x-m-t-30" style="height: 65vh;overflow: auto;">
        <!-- <div class="x-font-16 x-m-t-10">商务热线</div>
        <div class="x-m-t-20 x-m-b-30 x-font-21 c-primary">400-862-5828</div>
        <div class="x-m-b-30">官方网址：http://www.sanmipos.com</div> -->
        <div class="x-font-16 x-p-b-20 x-flex" v-for="(item,index) in mchTotalInfo">
          <div class='x-flex-1'>{{item.user_ip}}</div>
          <div class='x-flex-1'>{{item.user_count}}</div>
        </div>
      </div>
    </el-dialog>

    <!-- 电子价签 -->
    <el-dialog :visible.sync="dzjqPop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="dzjqClose">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">电子价签</div>
        <div class="x-flex">
          <!-- <el-button type="danger" size="small" @click="fPaymentDisposeSave">保存</el-button> -->
          <!-- <el-button style="width: 60px;" type="info" size="small" @click="dzjqClose">关闭</el-button> -->
          <div class="x-lh-32" @click="dzjqClose">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <div>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="5">
            <div class="x-w70  x-text-c">门店ID</div>
            <div class="x-lh-32">{{mall_id}}</div>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w70  x-text-c">价签ID</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="dzjqInfo.dzjq_id"
              @change="dzjqInfo.dzjq_name = dzjqInfo.dzjq_id+'价签'">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w70  x-text-c">价签名称</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="dzjqInfo.dzjq_name">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="3">
            <el-button style="width: 60px;" type="danger" size="small" @click="fElabelOper('ADD')">增加</el-button>
          </el-col>
        </el-row>
        <el-row class="x-p-t-20">
          <el-col>
            <vxe-table border highlight-hover-row height="380px" :data="dzjqData" align="center" ref="xTable1"
              style="width: 100%;">
              <vxe-column field="RC" width='80px' title="序号"></vxe-column>
              <vxe-column field="label_id" min-width='90px' title="价签ID"></vxe-column>
              <vxe-column field="label_name" min-width='90px' title="价签名称"></vxe-column>
              <vxe-column field="mall_id" min-width='90px' title="门店编码"></vxe-column>
              <vxe-column field="chg_time" min-width='90px' title="修改时间"></vxe-column>
              <vxe-column fixed="right" title="操作" width="70px" style="margin-bottom: 20px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="" style="color: #f56c6c"
                    @click="fElabelOper('DEL',scope.row.label_id,scope.row.label_name)">
                    删除
                  </el-button>
                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
        </el-row>
        <div class="x-flex x-row-between x-p-t-10" style="margin-right: -10px;">
          <div class="x-flex ">
            <el-radio v-model="dzjqRadio" label="0001" class="x-m-l-20 x-m-r-5">全部</el-radio>
            <el-radio v-model="dzjqRadio" label="本店" class="x-m-l-5 x-m-r-20">本店</el-radio>
            <div style="width: 300px">
              <el-input placeholder="" v-model="dzjqSearchStr" size="medium" class="x-m-r-12 x-flex-1">
                <el-button slot="append" @click="fGetDzjqList(1)">搜索</el-button>
                <!-- <template slot="append">搜索</template> -->
              </el-input>
            </div>
          </div>
          <el-pagination background layout="prev, pager, next" :total="Number(dzjqTR)" :page-size='20'
            @current-change="fGetDzjqList" :current-page="dzjqNowPage">
          </el-pagination>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
  import adr from "../assets/js/adr.js";
  import QRCode from "qrcodejs2";
  import md5 from 'js-md5'
  import {
    Loading
  } from 'element-ui';
  export default {
    data() {
      return {
        showQcSj: false,
        showKhdBbTs: false,
        dzjqRadio: '本店',
        dzjqSearchStr: '',
        dzjqPop: false, //电子价签
        dzjqData: [],
        dzjqNowPage: 1,
        dzjqTR: 0,
        dzjqInfo: {
          dzjq_id: '',
          dzjq_name: '',
        },
        payShowMore: false,
        shen: "",
        shi: "",
        qu: "",
        radio: "条件查询",
        merInputVal: "",
        searchAddressVal: "", //
        searchTypeVal: "商户", //
        // searchSortVal: "注册时间降序", //
        checked: true, //
        buySoftware: false, // 购买软件
        buySoftwareMoney: "", // 购买软件的金额
        goBuyDialog: false, // 购买软件付款界面
        buySuccess: false, // 付款成功的界面
        buyFail: false, // 付款失败的界面
        addMerchant: false, // 增加商户
        merchantAddOrEdit: "ADD", //  判断增加还是修改商户的标志
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        paymentDispose: false, // 支付配置
        mallDispose: false, // 配置门店
        mallDisposeInfo: {}, // 全局的点击操作的 商户信息
        innerModifyMall: false, // 内层的门店修改对话框
        innerModifyMallTitle: "", // 内层的门店修改对话框的标题
        modifyOrAddMallType: "", // 判断增加还是修改的标志
        buyType: "",
        forceUpdateOtion: [{
            name: '是',
            val: 'Y'
          },
          {
            name: '否',
            val: 'N'
          },
        ],
        timeRadio: 'REG',
        time: [this.bykApi.timeHelper.manyDaysAgo(30, 3) + ' 00:00:00', this.bykApi.timeHelper.manyDaysAgo(0, 3) +
          ' 23:59:59'
        ],
        lastTime: this.bykApi.timeHelper.manyDaysAgo(0, 3),

        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        shInfo: {
          mchSrvIp: this.bykApi.global.fGetPlatform().partnerInfo.data.fwq_ip,
          partnerPhone: this.bykApi.global.fGetPlatform().partnerInfo.phone,
          shEdition: "零售5.0", // 软件版本
          shPhone: "", // 手机号码
          shLxName: "", // 联系人名
          shUserType: "标准用户", // 用户类型
          shMallName: "", // 门店名称
          shIndustry: "便利店", // 所属行业
          shMainMarketing: "", // 主要经营
          // shMallAddress: "", // 门店地址
          shMallDetailAddress: "", // 门店详细地址
          shRemarks: "", // 备注信息
          shHomeUrl: "", // 主页网址
          jm_mall_can_use_num: "0",
          shAdUrl: "", // 广告网址
          shAdChoose: false, // 副屏广告统一管理是否选中
          wsYn: false,
          shCustomModelName: "", // 自定模块名
          shCustomModelUrl: "", // 自定网址
          shCustomModelChoose: false, // 自定模块打开独立浏览
          shAllCost: "299", // 全部费用
          mustPayCount: '3',
          shCanUseComputed: "3", // 可用电脑
          shShopMallExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 商城到期
          shOrderGoodsExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 订货到期
          org_ak: '',
          org_sk: '',
        },
        // payWayType: "贝友PAY", // 支付绑定
        paymentInfo: {
          payOrgId: '',
          payOrgMchId: '',
          wxSubMchId: '',
          wxAppId: '',
          wxMinAppId: '',
          payWay: "", // 支付方式
          payWayChoose: false, // 支付宝使用官方支付（可实时到账）
          bossName: "", // 老板姓名
          bossPhone: "", // 老板电话
          payRemarks: "", // 备注
          fwsName: "", // 服务商名
          fwsPhone: "", // 服务商电话
          // 贝友 Pay 参数
          bykShCode: "", // 贝友客 商户编号
          bykPaySecretKey: "", // 贝友客 支付密匙
          bykMallId: "", // 贝友客 门店编码
          //尚米pay
          smShCode: '', //尚米 服务商OrgId
          smPaySecretKey: '', //尚米 商户编码
          smMallId: '', //尚米 门店编码
          // 乐刷
          // 中国银联
          ylShCode: "", // 中国银联 商户编号
          ylPaySecretKey: "", // 中国银联 支付密匙
          ylPayMallId: '',
          //平安银行
          payhShCode: '', //平安银行商户编号
          payhPaySecretKey: '', //平安银行支付密匙
          // 微邮付
          wyfShCode: "", // 微邮付 商户编号
          wyfPaySecretKey: "", // 微邮付 支付密匙
          // 付呗
          fbMallId: "", // 付呗 门店ID
          fbAppId: "", // 付呗 appid
          fbAppSecret: "", // AppSecret
          // 随行付
          sxfDlsOrgId: "", // 随行付  代理商 orgId
          sxfShCode: "", // 随行付 商户编号
          sxfMallCode: '', //随行付 门店编码
          //汇付斗拱
          hfdgAppId: '', //汇付斗拱
          hfdgAppMallId: '',
          // 阿里云支付
          aliAppId: "", // 阿里云支付  appid
          aliMallId: "", // 阿里云支付 门店号
          aliShId: '', //阿里云支付 商户号
          // 盒子
          hzShCode: "", // 盒子 商户编码
          hzMallCode: "", // 盒子 门店编号
          // 东之付
          dzfMallId: "", // 东之付 门店ID
          dzfAppId: "", // 东之付 appid
          dzfAppSecret: "", // AppSecret
          // 德宏农行付
          hdMallId: "", // 商户号AppMallId
          hdAppId: "", // 终端号AppId
          hdAppSecret: "", // AppSecret
          // 山西信合
          sxxhShCode: "", // 山西信合 商户编码
          sxxhOfflineCode: "", // 山西信合 线下编号
          //银商支付
          ysAppId: '',
          ysAppSecret: '',
          ysAppMallId: '',
          //拉卡拉
          lklAppId: '',
          lklAppSecret: '',
          lklAppMallId: '',
          //京东支付
          jdzfShCode: '',
          jdzfMallId: '',
          jdzfMy: "",
          //河马付
          hmAppId: "",
          hmSubAppId: "",
          hmStoreNo: "",
          // 信联付
          xlfAppId: "",
          xlfAppSercet: "",
          //其他支付
          qtAppId: '',
          qtAppSecret: '',
          qtMallId: '',
        },
        mall_id: "", // 生成二维码时使用
        shServerIp: "", // 商户服务器 IP
        mallInfo: {
          mallId: "",
          mallName: "",
          sfFaRadio: "按存储收费", //收费方案
          mallAnnualFee: "299",
          mdMoney: '299',
          expireTime: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
          zb_renew: false, // 是否总部续费
          androidVer: Number(this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd')),
          winVer: Number(this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd')),
          forceUpdateYn: 'N'
        },
        // 软件版本下拉框的数据
        shEditionOptions: [{
            value: "零售5.0",
            label: "零售5.0",
          }, {
            value: "零售3.0",
            label: "零售3.0",
          },

          {
            value: "餐饮3.0",
            label: "餐饮3.0",
          },
        ],
        shUserTypeOptions: [{
            value: "免费用户",
            label: "免费用户",
          },
          {
            value: "标准用户",
            label: "标准用户",
          },
        ],
        shIndustryOptions: [{
            value: "饮品奶茶",
            label: "饮品奶茶",
          },
          {
            value: "中式餐厅",
            label: "中式餐厅",
          },
          {
            value: "西式餐厅",
            label: "西式餐厅",
          },
          {
            value: "火锅店",
            label: "火锅店",
          },
          {
            value: "果蔬生鲜",
            label: "果蔬生鲜",
          },
          {
            value: "便利店",
            label: "便利店",
          },
          {
            value: "小型超市",
            label: "小型超市",
          },
          {
            value: "休闲食品",
            label: "休闲食品",
          },
          {
            value: "烟酒糖茶",
            label: "烟酒糖茶",
          },
          {
            value: "母婴用品",
            label: "母婴用品",
          },
          {
            value: "化妆品",
            label: "化妆品",
          },
          {
            value: "饰品礼品",
            label: "饰品礼品",
          },
          {
            value: "家居家纺",
            label: "家居家纺",
          },
          {
            value: "保健食品",
            label: "保健食品",
          },
          {
            value: "办公用品",
            label: "办公用品",
          },
          {
            value: "体育用品",
            label: "体育用品",
          },
          {
            value: "服装鞋帽",
            label: "服装鞋帽",
          },
          {
            value: "皮具箱包",
            label: "皮具箱包",
          },
          {
            value: "家电数码",
            label: "家电数码",
          },
          {
            value: "户外用品",
            label: "户外用品",
          },
          {
            value: "汽车用品",
            label: "汽车用品",
          },
          {
            value: "农资用品",
            label: "农资用品",
          },
          {
            value: "农副用品",
            label: "农副用品",
          },
          {
            value: "宠物店",
            label: "宠物店",
          },
          {
            value: "其他",
            label: "其他",
          },
        ],
        payWayOptions: [
          // {
          //   label: "贝友PAY",
          //   value: "贝友PAY",
          // },
          // {
          //   label: "乐刷",
          //   value: "乐刷",
          // },

          {
            label: "尚米PAY",
            value: "尚米PAY",
          },
          {
            label: "银商支付",
            value: "银商支付",
          },
          {
            label: "拉卡拉",
            value: "拉卡拉",
          },
          {
            label: "京东支付",
            value: "京东支付",
          },
          {
            label: "河马付",
            value: "河马付",
          },
          {
            label: "信联付",
            value: "信联付",
          },
          {
            label: "平安银行",
            value: "平安银行",
          },
          {
            label: "中国银联",
            value: "中国银联",
          },
          {
            label: "微邮付",
            value: "微邮付",
          },
          {
            label: "付呗",
            value: "付呗",
          },
          {
            label: "随行付",
            value: "随行付",
          },
          {
            label: "汇付斗拱",
            value: "汇付斗拱",
          },
          {
            label: "阿里云支付",
            value: "阿里云支付",
          },
          {
            label: "盒子",
            value: "盒子",
          },
          {
            label: "东之付",
            value: "东之付",
          },
          {
            label: "德宏农行付",
            value: "德宏农行付",
          },

          {
            label: "陕西信合",
            value: "陕西信合",
          },
          {
            label: "其他支付",
            value: "其他支付",
          },
        ],
        // sortOptions: [
        //   {
        //     label: "注册时间降序",
        //     value: "注册时间降序",
        //   },
        //   {
        //     label: "最后登录降序",
        //     value: "最后登录降序",
        //   },
        //   {
        //     label: "商品数降序",
        //     value: "商品数降序",
        //   },
        //   {
        //     label: "门店数降序",
        //     value: "门店数降序",
        //   },
        //   {
        //     label: "支付账户降序",
        //     value: "支付账户降序",
        //   },
        //   {
        //     label: "注册时间升序",
        //     value: "注册时间升序",
        //   },
        //   {
        //     label: "最后登录升序",
        //     value: "最后登录升序",
        //   },
        //   {
        //     label: "商品数升序",
        //     value: "商品数升序",
        //   },
        //   {
        //     label: "门店数升序",
        //     value: "门店数升序",
        //   },
        //   {
        //     label: "支付账户升序",
        //     value: "支付账户升序",
        //   },
        // ],
        shMallAddressOptions: adr.adr,
        tableData: [],
        tableJson: [{
            // 循环渲染数据
            title: "来源",
            width: "90",
            sortType: "t_from",
          },
          {
            // 循环渲染数据
            title: "软件版本",
            width: "100",
            sortType: "soft_bb",
          },
          {
            // 循环渲染数据
            title: "版本号",
            width: "170",
            sortType: "soft_ver",
          },
          {
            title: "OEM",
            width: "80",
            sortType: "oem_yn",
          },
          {
            title: "手机号",
            width: "120",
            sortType: "user_phone",
          },
          {
            title: "联系人名",
            width: "110",
            sortType: "user_name",
          },
          {
            title: "门店名称",
            width: "170",
            sortType: "mall_name",
          },
          {
            title: "门店数",
            width: "90",
            sortType: "mall_count",
          },
          // {
          //    title: "加盟门店数",
          //    width: "120",
          //    sortType: "jm_mall_num",
          //  },
          {
            title: "可用加盟门店数",
            width: "140",
            sortType: "jm_mall_can_use_num",
          },
          {
            title: "所属行业",
            width: "100",
            sortType: "bus_type",
          },
          {
            title: "商品数",
            width: "90",
            sortType: "pro_count",
          },
          {
            title: "上日进货",
            width: "100",
            sortType: "pre_day_in_money",
          },
          {
            title: "上日批发",
            width: "100",
            sortType: "pre_day_pf_money",
          },
          {
            title: "上日零售",
            width: "100",
            sortType: "pre_day_pos_money",
          },
          {
            title: "近30天进货",
            width: "120",
            sortType: "pre_30day_in_money",
          },
          {
            title: "近30天批发",
            width: "120",
            sortType: "pre_30day_pf_money",
          },
          {
            title: "近30天零售",
            width: "120",
            sortType: "pre_30day_pos_money",
          },
          {
            title: "上日扫码",
            width: "100",
            sortType: "pre_day_scan_money",
          },
          {
            title: "近30天扫码",
            width: "120",
            sortType: "pre_30day_scan_money",
          },
          {
            title: "年费",
            width: "80",
            sortType: "nf_money",
          },
          {
            title: "注册时间",
            width: "180",
            sortType: "creat_time",
          },
          {
            title: "最后登录时间",
            width: "180",
            sortType: "last_login_time",
          },
          {
            title: "最后登录设备",
            width: "200",
            sortType: "last_login_device",
          },
          {
            title: "支付账户",
            width: "170",
            sortType: "online_zh_name",
          },
          {
            title: "省",
            width: "90",
            sortType: "shen",
          },
          {
            title: "市",
            width: "90",
            sortType: "shi",
          },
          {
            title: "区",
            width: "90",
            sortType: "qu",
          },
          {
            title: "门店地址",
            width: "300",
            sortType: "address",
          },
          {
            title: "备注",
            width: "200",
            sortType: "bz_memo",
          },
          {
            title: "开户人",
            width: "130",
            sortType: "partner_name",
          },
          {
            title: "代理商",
            width: "140",
            sortType: "comp_name",
          },
          {
            title: "代理商手机号",
            width: "120",
            sortType: "partner_phone",
          },
          {
            title: "代理商地址",
            width: "280",
            sortType: "comp_address",
          },
          {
            title: "上级",
            width: "130",
            sortType: "p_partner_name",
          },
          {
            title: "上级公司",
            width: "200",
            sortType: "p_comp_name",
          },
        ],
        mallData: [],
        payWayData: [], // 支付配置 中 已经配置过的支付方式
        addr: [],
        QRCodeEnlargeDialog: false, // 二维码放大弹框
        selfRegDialog: false, // 自主注册二维码放大
        cancelAllDataDialog: false, // 清除所有数据
        cancelDataTypeIdx: "1", // 要删除的数据类型
        partnerPwd: "", // 商户的登录密码  用于清除所有的数据
        cancelDataTime: [new Date(), new Date()], // 清楚数据是选择的时间段
        pickerOptions: {
          // 选择时间是的快捷方式
          shortcuts: [{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        mchTotalPop: false,
        mchTotalInfo: {},
        //门店续费
        mallXfData: [],
        //日志推送版本
        logOption: [{
          val: 'winPc',
        }, {
          val: 'androidPad',
        }, ],
        logSet: {
          logVer: 'winPc',
          logMallId: '',
        },
        logGet: {
          logVer: '',
          logDate: this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd'),
          logMallId: '',
        },
        custom: {
          custom_yn: 'N',
          custom_name: '',
          custom_url: '',
          custom_ex: '',
        },
        downLoadUrl: ''
      };
    },
    async created() {


      if (this.bykApi.smCom.fSmIsEmpty(this.bykApi.global.fGetPlatform().partnerInfo.data.pay_info)) {
        this.payWayOptions = [{
          label: "尚米PAY",
          value: "尚米PAY",
        }, ]
      } else {
        let payArr = JSON.parse(this.bykApi.global.fGetPlatform().partnerInfo.data.pay_info);
        let result = this.payWayOptions.filter(item => payArr.includes(item.label));
        this.payWayOptions = result
      }
      this.showQcSj = await this.bykApi.global.fGetSmMenuQx('清除所有数据')
      this.showKhdBbTs = await this.bykApi.global.fGetSmMenuQx('客户端版本推送')
      console.log(this.payWayOptions)
      this.init();
    },
    watch: {
      timeRadio() {
        this.init();
      },
      dzjqRadio() {
        this.fGetDzjqList(1)
      }
    },
    methods: {
      fCreatedAkSk(type) {
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shPhone)) {
          return this.$message("手机号码不能为空");
        }
        if (type == 'org_ak') {
          this.shInfo.org_ak = md5('smSoft_' + this.shInfo.shPhone + '_smSell')
          console.log(md5('smSoft_' + this.shInfo.shPhone + '_smSell'))
        }
        if (type == 'org_sk') {
          this.shInfo.org_sk = md5('smSell_' + this.shInfo.shPhone + '_smSoft')
        }
      },
      async init(nowPage) {
        // console.log(this.radio, this.shen, this.shi, this.qu);
        // if (
        // this.radio == "区域查询" &&
        //   this.bykApi.smCom.fSmIsEmpty(this.shen) &&
        //   this.bykApi.smCom.fSmIsEmpty(this.shi) &&
        //   this.bykApi.smCom.fSmIsEmpty(this.qu)
        // ) {
        //   return this.$message("请选择区域");
        // }
        // this.shInfo.shHomeUrl =
        //   this.bykApi.global.fGetPlatform().partnerInfo.data.main_url;
        // this.shShopMallExpice = "2021-2-22";
        // console.log(res);

        let res = await this.fBykGetShInfo();

        // console.log(res);
        if (res.result == "sucess") {
          this.tableData = res.data;
          this.TR = 0
          this.TP = 0
          if (res.data.length > 0) {
            this.TR = res.data[0].TR;
            this.TP = res.data[0].TP;
          }
        } else {
          return this.$message(res.msg);
        }
      },
      //表格导出
      fExportDataEvent() {
        this.$refs.xTable1.exportData({
          type: 'csv'
        })
      },
      fBuyChoose(type) {
        this.buyType = type;
      },
      fGoBuy(price) {
        this.buySoftwareMoney = price;
        this.goBuyDialog = !this.goBuyDialog;
        // this.buySuccess = !this.buySuccess;
        // this.buyFail = !this.buyFail;
        setTimeout(() => {
          this.buySoftware = !this.buySoftware;
        }, 0);
      },

      // 注册商户
      fRegMerchant() {
        // if (Number(this.bykApi.global.fGetPlatform().partnerInfo.data.can_reg_user_num) <= 0) {
        //   this.fSelfReg()
        //   return
        // }
        this.addMerchant = !this.addMerchant;
        this.merchantAddOrEdit = "ADD";
        this.shInfo.shHomeUrl =
          this.bykApi.global.fGetPlatform().partnerInfo.data.main_url;
        this.shInfo.shAllCost =
          Number(
            this.bykApi.global.fGetPlatform().partnerInfo.data.partner_base_price
          ) < 36.5 ?
          "36.5" :
          this.bykApi.global.fGetPlatform().partnerInfo.data
          .partner_base_price;
      },
      // 软件版本 change 事件
      shEditionChange(val) {

        this.shInfo.shEdition = val[0];
      },
      // 用户类型 change 事件
      shUserTypeChange(val) {
        this.shInfo.shUserType = val[0];
      },
      // 所属行业 change 事件
      shIndustryChange(val) {
        this.shInfo.shIndustry = val[0];
      },
      // 门店地址 change 事件
      shMallAddressChange(e) {
        this.addr = JSON.parse(JSON.stringify(e));

        // this.shInfo.shMallAddress = e[0] + "-" + e[1] + "-" + e[2];
        // console.log(e, this.shInfo.shMallAddress);
      },

      fHeadAddressChange(e) {
        this.shen = e[0];
        this.shi = e[1];
        this.qu = e[2];
        this.searchAddressVal = e[0] + "-" + e[1] + "-" + e[2];
        this.merInputVal = "";
      },
      fHeadTypeChange(e) {
        this.searchTypeVal = e[0];
      },

      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fHeadRadioChange() {
        this.searchAddressVal = "";
        this.merInputVal = "";
        this.init();
      },
      // 自主注册
      fSelfReg() {
        this.selfRegDialog = true;
        this.fSelfQrCreate()
      },

      // 新增商户
      async fAddMerchant() {
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shEdition)) {
          return this.$message("软件版本不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shPhone)) {
          return this.$message("手机号码不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shLxName)) {
          return this.$message("联系人名不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shUserType)) {
          return this.$message("用户类型不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shMallName)) {
          return this.$message("门店名称不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shIndustry)) {
          return this.$message("所属行业不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shMainMarketing)) {
          return this.$message("主要经营不能为空");
        }

        if (this.addr.length == 0) {
          return this.$message("门店地址不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shMallDetailAddress)) {
          return this.$message("门店详细地址不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shHomeUrl)) {
          return this.$message("主页网址不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.jm_mall_can_use_num)) {
          return this.$message("可用加盟门店不能为空");
        }

        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shCanUseComputed)) {
          return this.$message("可用电脑不能为空");
        }
        console.log(this.shInfo.shShopMallExpice)
        // if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shShopMallExpice)) {
        //   return this.$message("商城到期不能为空");
        // }
        // if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shOrderGoodsExpice)) {
        //   return this.$message("订货到期不能为空");
        // }
        let res = await this.fBykSellShReg();
        if (res.result == "sucess") {
          this.addMerchant = false;
          this.$alert("默认工号：1001,密码手机后四位", "开户成功", {
            confirmButtonText: "确定",
            callback: () => {
              this.init();
            },
          });
          return;
        }
        return this.$message(res.msg);
      },
      // 保存商户
      async fSaveMerchant() {
        // if(this.shInfo.shEdition == '零售5.0'){
        let resUpdate = await this.fExecSqlFile()
        if (resUpdate.result != "sucess") {
          this.$message(resUpdate.msg);
        }
        // }
        let res = await this.fBykSellShEdit();
        // console.log(res);
        if (res.result == "sucess") {
          this.init();
          this.fClose();
          this.$message(res.msg);
          return;
        }
        // this.addMerchant = false;
        return this.$message(res.msg);
        // console.log(this.shInfo);
      },
      // 关闭
      fClose() {
        this.addMerchant = false;
        this.addr = [];
        this.shInfo = Object.assign({}, {
          mchSrvIp: this.bykApi.global.fGetPlatform().partnerInfo.data.fwq_ip,
          partnerPhone: this.bykApi.global.fGetPlatform().partnerInfo.phone,
          shEdition: "零售5.0", // 软件版本
          shPhone: "", // 手机号码
          shLxName: "", // 联系人名
          shUserType: "标准用户", // 用户类型
          shMallName: "", // 门店名称
          shIndustry: "便利店", // 所属行业
          shMainMarketing: "", // 主要经营
          // shMallAddress: "", // 门店地址
          shMallDetailAddress: "", // 门店详细地址
          shRemarks: "", // 备注信息
          shHomeUrl: "", // 主页网址
          jm_mall_can_use_num: '0',
          shAdUrl: "", // 广告网址
          shAdChoose: false, // 副屏广告统一管理是否选中
          wsYn: false,
          shCustomModelName: "", // 自定模块名
          shCustomModelUrl: "", // 自定网址
          shCustomModelChoose: false, // 自定模块打开独立浏览
          shAllCost: "299", // 全部费用
          mustPayCount: '3',
          shCanUseComputed: "3", // 可用电脑
          shShopMallExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 商城到期
          shOrderGoodsExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 订货到期
          org_ak: '',
          org_sk: '',
        });
      },

      // 排序
      async fHeadSort(type, asc_desc = "") {
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        let res = await this.fBykGetShInfo();
        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      // 配置门店的内层弹框
      fInnerClose() {
        this.innerModifyMall = false;
        Object.assign(this.mallInfo, {
          sfFaRadio: "按存储收费", //收费方案
          mallId: "",
          mallName: "",
          mallAnnualFee: "299",
          // mdMoney:'299',
          expireTime: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ),
          zb_renew: "N",
        });
      },

      // 表头点击事件
      fTablePhoneClick(e) {

      },

      // 每个商户的修改按钮
      async fModify(row) {
        this.merchantAddOrEdit = "EDIT";
        let res = await this.fBykGetShId(row);

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.shServerIp = row.user_ip
        this.shServerUrl = row.load_url

        this.addMerchant = !this.addMerchant;
        this.shInfo.mchSrvIp = res.fy_info[0].user_ip;
        this.shInfo.shEdition = res.data[0].soft_bb;
        this.shInfo.shPhone = res.data[0].user_phone;
        this.shInfo.partnerPhone = res.data[0].partner_phone;
        this.shInfo.shLxName = res.data[0].user_name;
        this.shInfo.shUserType = res.data[0].user_type;
        this.shInfo.shMallName = res.data[0].mall_name;
        this.shInfo.shIndustry = res.data[0].bus_type;
        this.shInfo.shMainMarketing = res.data[0].bus_memo;
        this.addr = [res.data[0].shen, res.data[0].shi, res.data[0].qu];
        this.shInfo.shMallDetailAddress = res.data[0].address;
        this.shInfo.shRemarks = res.fy_info[0].bz_memo;
        this.shInfo.shHomeUrl = res.data[0].main_url;

        this.shInfo.shAdUrl = res.data[0].gg_url;
        this.shInfo.shAdChoose = res.data[0].gg_ty_yn == "Y" ? true : false;
        this.shInfo.wsYn = res.data[0].ws_yn == "Y" ? true : false;
        this.shInfo.shCustomModelName = res.data[0].shop_name;
        this.shInfo.shCustomModelUrl = res.data[0].shop_url;
        this.shInfo.shCustomModelChoose =
          res.data[0].shop_url_to_yn == "Y" ? true : false;
        this.shInfo.shAllCost = res.fy_info[0].nf_money;
        this.shInfo.jm_mall_can_use_num = res.fy_info[0].jm_mall_can_use_num;
        this.shInfo.mustPayCount = res.data[0].must_pay_count
        this.shInfo.shCanUseComputed = res.data[0].pc_can_use_num;
        this.shInfo.org_ak = res.data[0].org_ak;
        this.shInfo.org_sk = res.data[0].org_sk;
        this.shInfo.shShopMallExpice = new Date(
          res.fy_info[0].sc_stop_time.split(" ")[0]
        );
        this.shInfo.shOrderGoodsExpice = new Date(
          res.fy_info[0].dh_stop_time.split(" ")[0]
        );
      },
      //删除商户
      async fDelMch() {
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fDelMchInfo(this.shInfo.shPhone);
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.init();
          this.fClose();
          this.$message(res.msg);
        }).catch(() => {});
      },
      // 每个商户的配置门店按钮
      async fDisposeMall(row) {
        // console.log(row);
        this.shServerIp = row.user_ip;
        this.shServerUrl = row.load_url;

        this.mallDisposeInfo = row;
        let res = await this.fBykShMallInfo();
        console.log(res)
        if (res.result == "sucess") {
          this.mallData = res.data;
          this.mallInfo.mdMoney = res.reg_info[0].sell_md_money
          this.mallInfo.androidVer = Number(res.reg_info_sub.andriod_ver)
          this.mallInfo.winVer = Number(res.reg_info_sub.win_ver)
          this.mallInfo.forceUpdateYn = res.reg_info_sub.force_update_yn
          this.mallDispose = !this.mallDispose;
          this.downLoadUrl = ''
          this.custom = {
            custom_yn: 'N',
            custom_name: '',
            custom_url: '',
            custom_ex: '',
          }
          this.logSet = {
            logVer: 'winPc',
            logMallId: '',
          }
          this.logGet = {
            logVer: '',
            logDate: this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd'),
            logMallId: '',
          }
          let resEx = await this.fMchRegEx({
            oper: 'GET'
          })
          if (resEx.result != "sucess") {
            return
          }
          this.custom = resEx.data
          if (this.bykApi.smCom.fSmIsEmpty(resEx.data.debug_mall_list)) {
            return
          }
          let debugMallList = JSON.parse(resEx.data.debug_mall_list)
          console.log(debugMallList)
          this.logSet.logMallId = debugMallList[this.logSet.logVer]
          // this.logSet:{
          //  logVer:'',
          //  logMallId:'',
          // },
          return;
        }
        console.log(this.mallInfo.mdMoney, 123)
        return this.$message(res.msg);
        // console.log(res);
      },
      // 每个商户的支付配置按钮
      async fPaymentDispose(row) {
        this.mall_id = row.mall_id;
        let res = await this.fBykShPayInfo(row);
        // console.log(res);
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.payWayData = res.data;
        let defaultPayway = res.data.find((item) => {
          return item.mr_mark == "是";
        });
        if (defaultPayway) {
          this.paymentInfo.payWay = defaultPayway.zh_name;
        }
        this.paymentBindingToggle();
        // console.log("row", row);
        this.paymentDispose = !this.paymentDispose;
      },

      // 支付配置弹框的点击保存
      async fPaymentDisposeSave() {
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bossName)) {
          return this.$message("老板姓名不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bossPhone)) {
          return this.$message("老板电话不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fwsName)) {
          return this.$message("服务商名不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fwsPhone)) {
          return this.$message("联系电话不能为空");
        }
        if (this.paymentInfo.payWay == "贝友PAY") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bykShCode)) {
          //   return this.$message("商户编号不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bykPaySecretKey)) {
            return this.$message("支付密匙不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bykMallId)) {
            return this.$message("门店编码不能为空");
          }
        }
        if (this.paymentInfo.payWay == "尚米PAY") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.smShCode)) {
          //   return this.$message("商户编码不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.smMallId)) {
            return this.$message("门店编码不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.smPaySecretKey)) {
            this.paymentInfo.smPaySecretKey = '1'
            // return this.$message("支付秘钥不能为空");
          }
        }
        if (this.paymentInfo.payWay == "中国银联") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.ylShCode)) {
          //   return this.$message("商户编号不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.ylPaySecretKey)) {
            return this.$message("支付密匙不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.ylPayMallId)) {
            return this.$message("终端号不能为空");
          }
        }
        if (this.paymentInfo.payWay == "平安银行") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.payhShCode)) {
          //   return this.$message("商户编号不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.payhPaySecretKey)) {
            return this.$message("注册号不能为空");
          }
        }
        if (this.paymentInfo.payWay == "微邮付") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.wyfShCode)) {
          //   return this.$message("商户编号不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.wyfPaySecretKey)) {
            return this.$message("支付密匙不能为空");
          }
        }
        if (this.paymentInfo.payWay == "乐刷") {}
        if (this.paymentInfo.payWay == "付呗") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fbAppId)) {
          //   return this.$message("AppId不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fbMallId)) {
            return this.$message("门店ID不能为空");
          }

          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fbAppSecret)) {
            return this.$message("AppSecret不能为空");
          }
        }
        if (this.paymentInfo.payWay == "随行付") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.sxfDlsOrgId)) {
          //   return this.$message("代理商 orgId 不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.sxfShCode)) {
            return this.$message("商户编号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "汇付斗拱") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hfdgAppId)) {
          //   return this.$message("商户编号 不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hfdgAppMallId)) {
            return this.$message("商户编号 不能为空");
          }
        }

        if (this.paymentInfo.payWay == "阿里云支付") {
          //APP_ID 商户号  APP_MALL_ID 门店编码  APP_SECRET 服务商号
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.aliShId)) {
          //   return this.$message("服务商码 不能为空");
          // }
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.aliAppId)) {
          //   return this.$message("商户编号 不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.aliMallId)) {
            return this.$message("门店编号 不能为空");
          }

        }

        if (this.paymentInfo.payWay == "盒子") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hzShCode)) {
          //   return this.$message("商户编码 不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hzMallCode)) {
            return this.$message("门店编号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "东之付") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.dzfAppId)) {
          //   return this.$message("AppId不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.dzfMallId)) {
            return this.$message("门店ID不能为空");
          }

          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.dzfAppSecret)) {
            return this.$message("AppSecret不能为空");
          }
        }
        if (this.paymentInfo.payWay == "德宏农行付") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hdAppId)) {
          //   return this.$message("终端号AppId不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hdMallId)) {
            return this.$message("商户号AppMallId不能为空");
          }

          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hdAppSecret)) {
            return this.$message("AppSecret不能为空");
          }
        }
        if (this.paymentInfo.payWay == "陕西信合") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.sxxhShCode)) {
          //   return this.$message("商户编码 不能为空");
          // }
        }
        if (this.paymentInfo.payWay == "银商支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.ysAppId)) {
            return this.$message("appid 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.ysAppSecret)) {
            return this.$message("商户号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.ysAppMallId)) {
            return this.$message("终端号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "拉卡拉") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.lklAppId)) {
            return this.$message("appid 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.lklAppSecret)) {
            return this.$message("终端号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.lklAppMallId)) {
            return this.$message("商户号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "京东支付") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.jdzfShCode)) {
          //   return this.$message("商户编号 不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.jdzfMallId)) {
            return this.$message("店铺编号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.jdzfMy)) {
            return this.$message("代理秘钥 不能为空");
          }

        }
        //河马付
        if (this.paymentInfo.payWay == "河马付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hmAppId)) {
            return this.$message("appId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hmSubAppId)) {
            return this.$message("subAppId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.hmStoreNo)) {
            return this.$message("storeNo 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "信联付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.xlfAppId)) {
            return this.$message("appId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.xlfAppSercet)) {
            return this.$message("AppSercet 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "其他支付") {
          // if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.qtAppId)) {
          //   return this.$message("支付名称 不能为空");
          // }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.qtAppSecret)) {
            return this.$message("支付账号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.qtMallId)) {
            return this.$message("门店编号 不能为空");
          }
        }


        let res = await this.fBykSellBandPay();

        // if (res.result == "sucess") {
        // this.paymentDispose = false;
        // }
        return this.$message(res.msg + "：" + res.data);
      },
      // 支付配置弹框的点击关闭
      fPaymentDisposeClose() {
        this.reductionData();
        this.paymentInfo.payWay = "贝友PAY";
        this.paymentDispose = false;
      },
      // 支付配置 支付方式的 change 事件
      fPayWayChange(e) {
        this.paymentInfo.payWay = e[0];
        // 进行数据值的还原
        this.reductionData();
        this.paymentBindingToggle();
        this.paymentDisposeOpened();
      },
      // 支付方式切换时 触发重新赋值
      paymentBindingToggle() {
        let payWay = this.paymentInfo.payWay;
        // 查找 返回的数据是否包含要查找的值
        let res = this.payWayData.find((item) => {
          return item.zh_name == payWay;
        });
        this.payShowMore = false
        if (!res) {
          if (payWay == "尚米PAY") {
            this.paymentInfo.smMallId = '10001';
          }
          return;
        }
        this.paymentInfo.payWayChoose = res.alipay_gfyn == "Y" ? true : false;
        this.paymentInfo.bossName = res.zh_user_name;
        this.paymentInfo.bossPhone = res.zh_user_phone;
        this.paymentInfo.payRemarks = res.user_memo;
        this.paymentInfo.fwsName = res.chg_person;
        this.paymentInfo.fwsPhone = res.chg_person_phone;

        this.paymentInfo.payOrgId = res.ex_info1;
        this.paymentInfo.payOrgMchId = res.ex_info2;
        this.paymentInfo.wxSubMchId = res.wx_sub_id;
        this.paymentInfo.wxAppId = res.ex_info3;
        this.paymentInfo.wxMinAppId = res.ex_info4;
        if (this.paymentInfo.payOrgId ||
          this.paymentInfo.payOrgMchId ||
          this.paymentInfo.wxSubMchId ||
          this.paymentInfo.wxAppId ||
          this.paymentInfo.wxMinAppId) {
          this.payShowMore = true
        }




        if (payWay == "贝友PAY") {
          this.paymentInfo.bykShCode = res.app_id;
          this.paymentInfo.bykPaySecretKey = res.app_secret;
          this.paymentInfo.bykMallId = res.app_mall_id;
        }
        if (payWay == "尚米PAY") {
          this.paymentInfo.smShCode = res.app_id;
          this.paymentInfo.smPaySecretKey = res.app_secret;
          this.paymentInfo.smMallId = res.app_mall_id;
        }
        if (payWay == "中国银联") {
          this.paymentInfo.ylShCode = res.app_id;
          this.paymentInfo.ylPaySecretKey = res.app_secret;
          this.paymentInfo.ylPayMallId = res.app_mall_id;
        }
        if (payWay == "平安银行") {
          this.paymentInfo.payhShCode = res.app_id;
          this.paymentInfo.payhPaySecretKey = res.app_secret;
        }
        if (payWay == "微邮付") {
          this.paymentInfo.wyfShCode = res.app_id;
          this.paymentInfo.wyfPaySecretKey = res.app_secret;
        }
        if (payWay == "付呗") {
          this.paymentInfo.fbMallId = res.app_mall_id;
          this.paymentInfo.fbAppId = res.app_id;
          this.paymentInfo.fbAppSecret = res.app_secret;
        }
        if (payWay == "随行付") {
          console.log(res)
          this.paymentInfo.sxfDlsOrgId = res.app_id;
          this.paymentInfo.sxfShCode = res.app_mall_id;
          this.paymentInfo.sxfMallCode = res.app_secret;

        }
        if (payWay == "汇付斗拱") {
          console.log(res)
          this.paymentInfo.hfdgAppId = res.app_id;
          this.paymentInfo.hfdgAppMallId = res.app_mall_id;

        }

        if (payWay == "阿里云支付") {
          console.log(res)
          // this.paymentInfo.aliShId = res.app_id;
          this.paymentInfo.aliMallId = res.app_mall_id;
          this.paymentInfo.aliAppId = res.app_id;

        }
        if (payWay == "盒子") {
          this.paymentInfo.hzShCode = res.app_id;
          this.paymentInfo.hzMallCode = res.app_mall_id;
        }
        if (payWay == "东之付") {
          this.paymentInfo.dzfMallId = res.app_mall_id;
          this.paymentInfo.dzfAppId = res.app_id;
          this.paymentInfo.dzfAppSecret = res.app_secret;
        }
        if (payWay == "德宏农行付") {
          this.paymentInfo.hdMallId = res.app_mall_id;
          this.paymentInfo.hdAppId = res.app_id;
          this.paymentInfo.hdAppSecret = res.app_secret;
        }
        if (payWay == "陕西信合") {
          this.paymentInfo.sxxhShCode = res.app_id;
          this.paymentInfo.sxxhOfflineCode = res.app_mall_id;
        }
        if (payWay == "银商支付") {
          this.paymentInfo.ysAppId = res.app_id;
          this.paymentInfo.ysAppSecret = res.app_secret;
          this.paymentInfo.ysAppMallId = res.app_mall_id;
        }
        if (payWay == "拉卡拉") {
          this.paymentInfo.lklAppId = res.app_id;
          this.paymentInfo.lklAppSecret = res.app_secret;
          this.paymentInfo.lklAppMallId = res.app_mall_id;
        }

        if (payWay == "京东支付") {
          this.paymentInfo.jdzfShCode = res.app_id;
          this.paymentInfo.jdzfMallId = res.app_mall_id;
          this.paymentInfo.jdzfMy = res.app_secret;

        }
        if (payWay == "河马付") {
          this.paymentInfo.hmAppId = res.app_id;
          this.paymentInfo.hmSubAppId = res.app_secret;
          this.paymentInfo.hmStoreNo = res.app_mall_id;
        }
        if (payWay == "信联付") {
          this.paymentInfo.xlfAppId = res.app_id;
          this.paymentInfo.xlfAppSercet = res.app_secret;
        }

        if (payWay == "其他支付") {
          this.paymentInfo.qtMallId = res.app_mall_id;
          this.paymentInfo.qtAppId = res.app_id;
          this.paymentInfo.qtAppSecret = res.app_secret;
        }



      },
      // 数据还原
      reductionData() {
        this.paymentInfo = Object.assign(this.paymentInfo, {
          payWayChoose: false, // 支付宝使用官方支付（可实时到账）
          payOrgId: "",
          payOrgMchId: "",
          wxSubMchId: "",
          wxAppId: "",
          wxMinAppId: "",
          bossName: "", // 老板姓名
          bossPhone: "", // 老板电话
          payRemarks: "", // 备注
          // 贝友 Pay 参数
          bykShCode: "", // 贝友客 商户编号
          bykPaySecretKey: "", // 贝友客 支付密匙
          bykMallId: "", // 贝友客 门店编码
          // 贝友 Pay 参数
          smShCode: "", // 贝友客 商户编号
          smPaySecretKey: "", // 贝友客 支付密匙
          smMallId: "", // 贝友客 门店编码
          // 乐刷
          // 中国银联
          ylShCode: "", // 中国银联 商户编号
          ylPaySecretKey: "", // 中国银联 支付密匙
          ylPayMallId: '',
          //平安银行
          payhShCode: '', //平安银行商户编号
          payhPaySecretKey: '', //平安银行支付密匙
          // 微邮付
          wyfShCode: "", // 微邮付 商户编号
          wyfPaySecretKey: "", // 微邮付 支付密匙
          // 付呗
          fbMallId: "", // 付呗 门店ID
          fbAppId: "", // 付呗 appid
          fbAppSecret: "", // AppSecret
          // 随行付
          sxfDlsOrgId: "", // 随行付  代理商 orgId
          sxfShCode: "", // 随行付 商户编号
          sxfMallCode: '', // 随行付 门店编码
          //汇付斗拱
          hfdgAppId: '',
          hfdgAppMallId: '',
          // 阿里云
          aliAppId: "", // 阿里云支付  appid
          aliMallId: "", // 阿里云支付 门店号
          aliShId: '', //阿里云支付 商户号
          // 盒子
          hzShCode: "", // 盒子 商户编码
          hzMallCode: "", // 盒子 门店编号
          // 东之付
          dzfMallId: "", // 东之付 门店ID
          dzfAppId: "", // 东之付 appid
          dzfAppSecret: "", // AppSecret
          // 德宏农行付
          fbMallId: "", // 商户号AppMallId
          fbAppId: "", // 终端号AppId
          fbAppSecret: "", // AppSecret
          // 陕西信合
          sxxhShCode: "", // 陕西信合 商户编码
          sxxhOfflineCode: "", // 陕西信合 线下编号
          //银商支付
          ysAppId: '',
          ysAppSecret: '',
          ysAppMallId: '',
          //拉卡拉
          lklAppId: '',
          lklAppSecret: '',
          lklAppMallId: '',
          // 京东支付
          jdzfShCode: "", // 京东支付 商户编码
          jdzfMallId: "", // 京东支付 线下编号
          jdzfMy: '',
          // 河马付
          hmAppId: '',
          hmSubAppId: '',
          hmStoreNo: '100001',
          // 信联付
          xlfAppId: '',
          xlfAppSercet: "",
          //其他支付
          qtAppId: '',
          qtAppSecret: '',
          qtMallId: '',
        });
      },

      // 重置门店信息
      async fResetMall() {
        this.$confirm(
          "此操作将 1001 密码重置为手机后四位，确认重置？",
          "重置密码", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(async () => {
          let res = await this.fBykSellResetPwd();
          return this.$message(res.msg);
        });
      },

      // 清除所有数据
      async fResetAllData() {
        let oper = "";
        let time1 = "";
        let time2 = "";

        if (this.cancelDataTypeIdx == "1") {
          oper = "YW_DATA";
        } else if (this.cancelDataTypeIdx == "2") {
          oper = "ALL_YW_DATA";
        } else if (this.cancelDataTypeIdx == "3") {
          oper = "ALL";
        }
        time1 =
          this.cancelDataTime[0].getFullYear() +
          "-" +
          (Number(this.cancelDataTime[0].getMonth()) + 1) +
          "-" +
          this.cancelDataTime[0].getDate();
        time2 =
          this.cancelDataTime[1].getFullYear() +
          "-" +
          (Number(this.cancelDataTime[1].getMonth()) + 1) +
          "-" +
          this.cancelDataTime[1].getDate();
        if (this.bykApi.smCom.fSmIsEmpty(oper)) {
          return this.$message("请选择要删除的业务类型");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.partnerPwd)) {
          return this.$message("请输入合作伙伴密码");
        }
        let loadingInstance = Loading.service({
          lock: true,
          text: '加载中……',
          background: 'rgba(0, 0, 0, 0)'
        })
        let res = await this.fBykSellClearData(oper, time1, time2);
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message("清除数据成功");
        this.cancelAllDataDialog = false;
      },

      // 退出
      fColseMall() {
        this.mallDispose = false;
      },
      // 修改或增加门店
      fModifyOrAddMall(row, type) {
        //判断权限
        this.modifyOrAddMallType = type;
        if (type == "modify") this.innerModifyMallTitle = "门店信息 > 修改门店";
        if (type == "add") this.innerModifyMallTitle = "门店信息 > 增加门店";

        // console.log(row);
        if (type == "modify") {
          this.mallInfo.mallId = row.mall_id;
          this.mallInfo.mallName = row.mall_name;
          this.mallInfo.mallAnnualFee = row.fy_money;
          // this.mallInfo.mdMoney = row.md_money;
          this.mallInfo.expireTime = new Date(row.stop_time);
          this.mallInfo.zb_renew = row.zb_xf_yn == "Y" ? true : false;
          // this.mallInfo.androidVer = Number(this.bykApi.timeHelper.manyDaysAgo(0, 3,'yyyyMMdd'))
          // this.mallInfo.winVer = Number(this.bykApi.timeHelper.manyDaysAgo(0, 3,'yyyyMMdd'))
          console.log(this.mallInfo.winVer)
        }
        if (type == 'add' && this.bykApi.global.fGetPlatform().partnerInfo.data.can_add_mall != 'Y') {
          return this.$message("暂无新增门店的权限");
        }
        this.innerModifyMall = !this.innerModifyMall;
      },

      // 内层弹框的  增加门店
      async fAddMall() {
        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.mallName)) {
          return this.$message("门店名称不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.mallAnnualFee)) {
          return this.$message("门店年费不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.mdMoney)) {
          return this.$message("终身费用不能为空");
        }

        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.expireTime)) {}

        // 增加接口
        let res = await this.fBykSellAddMall();
        if (res.result == "sucess") {
          // this.innerModifyMall = false;
          this.fInnerClose();
          // 获取接口
          let res = await this.fBykShMallInfo();
          if (res.result == "sucess") {
            this.mallData = res.data;
            this.mallInfo.mdMoney = res.reg_info[0].sell_md_money
            // this.mallDispose = !this.mallDispose;
            this.init();
            return;
          }
        }
        return this.$message(res.msg);
      },

      // 内层弹框的  修改门店
      async fEditMall() {
        let res = await this.fBykSellEditMall();
        if (res.result == "sucess") {
          // this.innerModifyMall = false;
          this.fInnerClose();
          this.init();
          let res = await this.fBykShMallInfo();
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.mallData = res.data;
          this.mallInfo.mdMoney = res.reg_info[0].sell_md_money

        }
        return this.$message(res.msg);
      },

      // 分页
      async fCurrentChange(e) {
        this.nowPage = e;
        let res = await this.fBykGetShInfo();
        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      // 支付配置弹框弹出后进行二维码的生成
      paymentDisposeOpened() {
        // document.getElementById("qrcode").innerHTML = "";
        // this.creatQrCode();
      },

      // 生成 二维码
      creatQrCode() {
        let payWay = this.paymentInfo.payWay;
        let zhName = null;
        if (payWay == "贝友PAY") {
          zhName = "BYP";
        }
        if (payWay == "尚米PAY") {
          zhName = "SMP";
        }
        if (payWay == "中国银联") {
          zhName = "ZGYL";
        }
        if (payWay == "平安银行") {
          zhName = "PAYH";
        }
        if (payWay == "微邮付") {
          zhName = "WYF";
        }
        if (payWay == "乐刷") {
          zhName = "LS";
        }
        if (payWay == "付呗") {
          zhName = "FB";
        }
        if (payWay == "随行付") {
          zhName = "SXF";
        }
        if (payWay == "盒子") {
          zhName = "HZ";
        }
        if (payWay == "东之付") {
          zhName = "LBN";
        }
        if (payWay == "德宏农行付") {
          zhName = "HDNHF";
        }
        if (payWay == "陕西信合") {
          zhName = "SXXH";
        }
        if (payWay == "京东支付") {
          zhName = "JDZF";
        }
        if (payWay == "河马付") {
          zhName = "HMF";
        }
        if (payWay == "信联付") {
          zhName = "XLF";
        }
        if (payWay == "银商支付") {
          zhName = "YSYH";
        }
        if (payWay == "拉卡拉") {
          zhName = "LKL";
        }




        var qrcode = new this.QRCode(this.$refs.qrCodeUrlMax, {
          text: `https://openauth.alipay.com/oauth2/appToAppAuth.htm?app_id=2021002147672969&redirect_uri=http%3A%2F%2Fwww.91byk.com%2FbyPay%2FbyPayAliAuth.html&shPhone=${this.mallDisposeInfo.user_phone}&shMallId=${this.mall_id}&compName=BYK&zhName=${zhName}&tFrom=bykSell`, // 需要转换为二维码的内容
          // text: "http://www.baidu.com",
          width: 600,
          height: 600,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        // this.QRCodeUrl = `https://openauth.alipay.com/oauth2/appToAppAuth.htm?app_id=2021002147672969&redirect_uri=http%3A%2F%2Fwww.91byk.com%2FbyPay%2FbyPayAliAuth.html&shPhone=${this.mallDisposeInfo.user_phone}&shMallId=${this.mall_id}&compName=BYK&zhName=${zhName}&tFrom=bykSell`;
      },
      // 生成 二维码
      // creatQrCodeMax() {
      //   // console.log(this.mallInfo);
      //   var qrcode = new this.QRCode(this.$refs.qrCodeUrlMax, {
      //     text: this.QRCodeUrl, // 需要转换为二维码的内容
      //     width: 600,
      //     height: 600,
      //     colorDark: "#000000",
      //     colorLight: "#ffffff",
      //     correctLevel: QRCode.CorrectLevel.H,
      //   });
      // },

      // 二维码放大
      fQRCodeEnlarge() {

        // document.getElementById("qrcode").innerHTML = "";
        // this.creatQrCode();
        this.QRCodeEnlargeDialog = !this.QRCodeEnlargeDialog;
      },
      // 放大后的二维码弹框开启事件
      maxQRCodeOpened() {
        // document.getElementById("qrcodeMax").innerHTML = "";
        // this.creatQrCodeMax();
        document.getElementById("qrcodeMax").innerHTML = "";
        this.creatQrCode();
      },

      // 设置付呗 H5 的支付路径
      async fSetFbWxH5Path() {
        let res = await this.fBykSetFbWxPayPath();

        if (res.result_code) {
          return this.$message(res.result_message);
        }
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message("设置付呗H5的支付路径成功");
      },
      //商户汇总
      async fShowMchTotal() {
        let res = await this.fGetMchTotal();
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.mchTotalInfo = res.data
        this.mchTotalPop = true
      },
      //测试
      fTest() {
        window.open("http://www.91byk.com/testSrvCon.html", '_blank');
      },
      //自助注册
      fSelfQrCreate() {
        setTimeout(() => {
          document.getElementById("selfQr").innerHTML = "";
          var qrcode = new this.QRCode(this.$refs.selfQrUrlMax, {
            text: `http://soft.sanmipos.com/smSell/index.html#/pages/shReg/shReg?o=${this.bykApi.global.fGetPlatform().partnerInfo.phone}&c=${this.bykApi.global.fGetPlatform().partnerInfo.data.comp_name}&reg=T`, // 需要转换为二维码的内容
            // text: "http://www.baidu.com",
            width: 300,
            height: 300,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });

        }, 200)

      },
      //电子价签  ========
      async fGetDzjqList(e) {
        // this.mall_id = row.mall_id;
        // this.dzjqPop = true
        if (!isNaN(e)) {
          this.dzjqNowPage = e
        } else {
          let dzjqQx = await this.bykApi.global.fGetSmMenuQx('电子价签')
          if (!dzjqQx) {
            return this.$message('暂无电子价签权限');
          }
          this.mall_id = e.mall_id;
          this.dzjqPop = true
        }
        let res = await this.fGetElabelInfo({
          oper: 'LIST',
          mallId: this.dzjqRadio == '本店' ? this.mall_id : '0001', //选择门店
        })
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.dzjqData = res.data
        if (res.data && res.length > 0) {
          this.dzjqTR = res.data[0].TR
        }
      },
      //关闭电子价签弹窗
      dzjqClose() {
        this.dzjqPop = false
        this.dzjqRadio = '本店'
      },
      //电子价签分页
      // fDzjqCurrentChange(e) {
      //   this.dzjqNowPage = e
      //   let res = await this.fGetElabelInfo({
      //     oper: 'LIST',
      //     mallId: this.mall_id,
      //   })
      //   if (res.result != "sucess") {
      //     return this.$message(res.msg);
      //   }
      //   this.dzjqData = res.data
      // },
      //电子价签操作
      async fElabelOper(oper, labelId, labelName) {
        if (oper == 'DEL') {
          this.$confirm('是否确认删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirmButton',
          }).then(async () => {
            let res = await this.fElabelInfo({
              oper,
              mallId: this.mall_id,
              labelId: labelId,
              labelName: labelName,
            })
            this.fGetDzjqList({
              mall_id: this.mall_id
            })
          }).catch(() => {});
          return
        }
        let res = await this.fElabelInfo({
          oper,
          mallId: this.mall_id,
          labelId: this.dzjqInfo.dzjq_id,
          labelName: this.dzjqInfo.dzjq_name,
        })
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.dzjqInfo.dzjq_id = ''
        this.dzjqInfo.dzjq_name = ''
        this.fGetDzjqList({
          mall_id: this.mall_id
        })

      },
      // ---------------------- 请求函数 开始 ------------------------
      async fElabelInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["CHG_USER_ID"] = '1001';
        js["MALL_ID"] = obj.mallId;
        js["LABEL_ID"] = obj.labelId;
        js["LABEL_NAME"] = obj.labelName;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('ELABEL_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        return res;
      },
      async fGetElabelInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["MALL_ID"] = obj.mallId;
        js["PAGE_SIZE"] = 20;
        js["NOW_PAGE"] = this.dzjqNowPage;
        js["SEARCH_STR"] = this.dzjqSearchStr;
        js["MH_YN"] = 'Y';
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellQueryApi('GET_ELABEL_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        return res;
      },
      async fGetMchTotal() {
        let js = {};
        js["OPER"] = "SRV_MCH_COUNT";
        // js["SH_PHONE"] = row.user_phone;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },
      // 获取商户列表信息
      async fBykGetShInfo() {
        // let desc = "desc";
        // let field = "creat_time";
        let js = {};
        js["OPER"] = "MCH_LIST";
        js["PAGE_SIZE"] = 50;
        js["NOW_PAGE"] = this.nowPage;
        // if (this.searchSortVal == "注册时间升序") {
        //   desc = "asc";
        // } else if (this.searchSortVal == "最后登录降序") {
        //   field = "last_login_time";
        // } else if (this.searchSortVal == "最后登录升序") {
        //   desc = "asc";
        //   field = "last_login_time";
        // } else if (this.searchSortVal == "商品数降序") {
        //   field = "pro_count";
        // } else if (this.searchSortVal == "商品数升序") {
        //   desc = "asc";
        //   field = "pro_count";
        // } else if (this.searchSortVal == "门店数降序") {
        //   field = "mall_count";
        // } else if (this.searchSortVal == "门店数升序") {
        //   desc = "asc";
        //   field = "mall_count";
        // } else if (this.searchSortVal == "支付账户降序") {
        //   field = "online_zh_name";
        // } else if (this.searchSortVal == "支付账户升序") {
        //   desc = "asc";
        //   field = "online_zh_name";
        // }
        js["TIME_TYPE"] = this.timeRadio;
        if (this.timeRadio == 'REG') {
          js["START_TIME"] = this.time[0];
          js["OVER_TIME"] = this.time[1];
        }
        if (this.timeRadio == 'LOGIN') {
          js["START_TIME"] = this.lastTime;
          js["OVER_TIME"] = this.lastTime;
        }

        // js["ASC_DESC"] = desc;
        // js["ASC_DESC_FIELD"] = field;
        js["ASC_DESC"] = this.sortAscDesc;
        js["ASC_DESC_FIELD"] = this.sortType;
        js["AREA_TYPE"] = this.searchTypeVal == "商户" ? "sh" : "partner";
        js["SHEN"] = this.shen;
        js["SHI"] = this.shi;
        js["QU"] = this.qu;
        js["SEARCH_STR"] = this.merInputVal;
        js["MH_YN"] = this.checked ? "Y" : "N";
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },

      // 获取商户详情信息
      async fBykGetShId(row) {
        let js = {};
        js["OPER"] = "MCH_ID";
        js["SH_PHONE"] = row.user_phone;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },
      // 删除商户详情信息
      async fDelMchInfo(phone) {
        let js = {};
        js["OPER"] = "DEL_MCH_MAIN";
        js["USER_PHONE"] = phone;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        console.log(res);
        return res;
      },

      // 新增商户信息
      async fBykSellShReg() {
        let js = {};
        let time1 = new Date(this.shInfo.shOrderGoodsExpice);
        let time2 = new Date(this.shInfo.shShopMallExpice);
        js["OPER"] = "ADD_MCH_MAIN";
        js["USER_PHONE"] = this.shInfo.shPhone; //商户手机号
        js["PARTNER_PHONE"] = this.shInfo.partnerPhone; //服务商手机号
        js["SOFT_BB"] = this.shInfo.shEdition; //版本号
        js["USER_TYPE"] = this.shInfo.shUserType; // 用户类型
        js["USER_NAME"] = this.shInfo.shLxName; //联系人
        js["SHEN"] = this.addr[0];
        js["SHI"] = this.addr[1];
        js["QU"] = this.addr[2];
        js["ADDRESS"] = this.shInfo.shMallDetailAddress;
        js["MALL_NAME"] = this.shInfo.shMallName; //门店名称
        js["BUS_TYPE"] = this.shInfo.shIndustry; //行业
        js["BUS_MEMO"] = this.shInfo.shMainMarketing; //主要经营
        js["BZ_MEMO"] = this.shInfo.shRemarks; //自助注册
        js["FY_MONEY"] = this.shInfo.shAllCost; //299

        js["MUST_PAY_COUNT"] = this.shInfo.mustPayCount //0
        js["MAIN_URL"] = this.shInfo.shHomeUrl; //''
        js["GG_TY_YN"] = this.shInfo.shAdChoose ? "Y" : "N"; //N
        js["WS_YN"] = this.shInfo.wsYn ? "Y" : "N"; //N
        js["GG_URL"] = this.shInfo.shAdUrl; //''
        js["SHOP_NAME"] = this.shInfo.shCustomModelName; //''
        js["SHOP_URL_TO_YN"] = this.shInfo.shCustomModelChoose ? "Y" : "N"; //''
        js["SHOP_URL"] = this.shInfo.shCustomModelUrl;
        js["PC_CAN_USE_NUM"] = this.shInfo.shCanUseComputed; //可用电脑数
        js["MCH_SRV_IP"] = this.shInfo.mchSrvIp; //
        js["ORG_AK"] = this.shInfo.org_ak;
        js["ORG_SK"] = this.shInfo.org_sk;
        js["DH_STOP_TIME"] =
          time1.getFullYear() +
          "-" +
          (time1.getMonth() - 0 + 1) +
          "-" +
          time1.getDate();
        js["SC_STOP_TIME"] =
          time2.getFullYear() +
          "-" +
          (time2.getMonth() - 0 + 1) +
          "-" +
          time2.getDate(); //+30
        console.log(isNaN("-01-16") && !isNaN(Date.parse("-01-16")))
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        console.log(res);
        return res;
      },

      // 修改商户信息
      async fBykSellShEdit() {
        // console.log(this.shInfo.shMallAddress);
        let js = {};
        let time1 = new Date(this.shInfo.shOrderGoodsExpice);
        let time2 = new Date(this.shInfo.shShopMallExpice);
        js["OPER"] = "EDIT_MCH_MAIN";
        // js["SH_PHONE"] = this.shInfo.shPhone;
        js["USER_PHONE"] = this.shInfo.shPhone;
        js["PARTNER_PHONE"] = this.shInfo.partnerPhone
        js["SOFT_BB"] = this.shInfo.shEdition;
        js["USER_TYPE"] = this.shInfo.shUserType;
        js["USER_NAME"] = this.shInfo.shLxName;
        js["SHEN"] = this.addr[0];
        js["SHI"] = this.addr[1];
        js["QU"] = this.addr[2];
        js["ADDRESS"] = this.shInfo.shMallDetailAddress;
        js["MALL_NAME"] = this.shInfo.shMallName;
        js["BUS_TYPE"] = this.shInfo.shIndustry;
        js["BUS_MEMO"] = this.shInfo.shMainMarketing;
        js["BZ_MEMO"] = this.shInfo.shRemarks;
        js["FY_MONEY"] = this.shInfo.shAllCost;
        js["MUST_PAY_COUNT"] = this.shInfo.mustPayCount
        js["MAIN_URL"] = this.shInfo.shHomeUrl;
        js["JM_MALL_CAN_USE_NUM"] = this.shInfo.jm_mall_can_use_num;
        js["GG_TY_YN"] = this.shInfo.shAdChoose ? "Y" : "N";
        js["WS_YN"] = this.shInfo.wsYn ? "Y" : "N";
        js["GG_URL"] = this.shInfo.shAdUrl;
        js["SHOP_NAME"] = this.shInfo.shCustomModelName;
        js["SHOP_URL_TO_YN"] = this.shInfo.shCustomModelChoose ? "Y" : "N";
        js["SHOP_URL"] = this.shInfo.shCustomModelUrl;
        js["PC_CAN_USE_NUM"] = this.shInfo.shCanUseComputed;
        js["ORG_AK"] = this.shInfo.org_ak;
        js["ORG_SK"] = this.shInfo.org_sk;
        js["DH_STOP_TIME"] =
          time1.getFullYear() +
          "-" +
          (time1.getMonth() - 0 + 1) +
          "-" +
          time1.getDate();
        js["SC_STOP_TIME"] =
          time2.getFullYear() +
          "-" +
          (time2.getMonth() - 0 + 1) +
          "-" +
          time2.getDate();
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        return res;
      },

      // 获取支付配置详情
      async fBykShPayInfo(row) {
        let js = {};
        js["OPER"] = 'MAIN_SRV ';
        js["SH_PHONE"] = this.mallDisposeInfo.user_phone;
        js["MALL_ID"] = row.mall_id;
        // console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MCH_ONLINE_PAY_INFO', js);
        // 15058125376
        return res;
      },

      // 支付配置
      async fBykSellBandPay() {
        let postJson = {};
        // postJson["METHOD_NAME"] = "BYK_SELL_BAND_PAY";
        // postJson["METHOD_NAME"] = "SMSELL_BAND_PAY";
        postJson["OPER"] = "MAIN_SRV";
        postJson["MCH_ID"] = this.mallDisposeInfo.user_phone;
        postJson["ZH_NAME"] = this.paymentInfo.payWay;
        postJson["MALL_ID"] = this.mall_id;
        postJson["ZH_USER_NAME"] = this.paymentInfo.bossName;
        postJson["ZH_USER_PHONE"] = this.paymentInfo.bossPhone;
        postJson["USER_MEMO"] = this.paymentInfo.payRemarks;
        postJson["CHG_PERSON"] = this.paymentInfo.fwsName;
        postJson["CHG_PERSON_PHONE"] = this.paymentInfo.fwsPhone;

        postJson["PAY_ORG_ID"] = this.paymentInfo.payOrgId;
        postJson["PAY_ORG_MCH_ID"] = this.paymentInfo.payOrgMchId;
        postJson["WX_SUB_MCH_ID"] = this.paymentInfo.wxSubMchId;
        postJson["WX_APP_ID"] = this.paymentInfo.wxAppId;
        postJson["WX_MIN_APP_ID"] = this.paymentInfo.wxMinAppId;

        postJson["MR_MARK"] = "是";
        postJson["ALI_PAY_GF_YN"] = this.paymentInfo.payWayChoose ? "Y" : "N";
        if (this.paymentInfo.payWay == "贝友PAY") {
          postJson["APP_ID"] = this.paymentInfo.bykShCode;
          postJson["APP_SECRET"] = this.paymentInfo.bykPaySecretKey;
          postJson["APP_MALL_ID"] = this.paymentInfo.bykMallId;
        }
        if (this.paymentInfo.payWay == "尚米PAY") {
          postJson["APP_ID"] = this.paymentInfo.smShCode;
          postJson["APP_SECRET"] = this.paymentInfo.smPaySecretKey;
          postJson["APP_MALL_ID"] = this.paymentInfo.smMallId;
        }
        if (this.paymentInfo.payWay == "中国银联") {
          postJson["APP_ID"] = this.paymentInfo.ylShCode;
          postJson["APP_SECRET"] = this.paymentInfo.ylPaySecretKey;
          postJson["APP_MALL_ID"] = this.paymentInfo.ylPayMallId;
        }
        if (this.paymentInfo.payWay == "平安银行") {
          postJson["APP_ID"] = this.paymentInfo.payhShCode;
          postJson["APP_SECRET"] = this.paymentInfo.payhPaySecretKey;
          postJson["APP_MALL_ID"] = "";
        }
        if (this.paymentInfo.payWay == "微邮付") {
          postJson["APP_ID"] = this.paymentInfo.wyfShCode;
          postJson["APP_SECRET"] = this.paymentInfo.wyfPaySecretKey;
          postJson["APP_MALL_ID"] = "";
        }
        if (this.paymentInfo.payWay == "乐刷") {
          postJson["APP_ID"] = "00010001";
          postJson["APP_SECRET"] = "";
          postJson["APP_MALL_ID"] = "";
        }
        if (this.paymentInfo.payWay == "付呗") {
          postJson["APP_ID"] = this.paymentInfo.fbAppId;
          postJson["APP_SECRET"] = this.paymentInfo.fbAppSecret;
          postJson["APP_MALL_ID"] = this.paymentInfo.fbMallId;
        }
        if (this.paymentInfo.payWay == "随行付") {
          postJson["APP_ID"] = this.paymentInfo.sxfDlsOrgId;
          postJson["APP_SECRET"] = this.paymentInfo.sxfMallCode;
          postJson["APP_MALL_ID"] = this.paymentInfo.sxfShCode;
        }
        if (this.paymentInfo.payWay == "汇付斗拱") {
          postJson["APP_ID"] = this.paymentInfo.hfdgAppId;
          postJson["APP_SECRET"] = ''
          postJson["APP_MALL_ID"] = this.paymentInfo.hfdgAppMallId
        }

        if (this.paymentInfo.payWay == "阿里云支付") {
          //APP_ID 商户号  APP_MALL_ID 门店编码  APP_SECRET 服务商号
          postJson["APP_ID"] = this.paymentInfo.aliAppId;
          postJson["APP_SECRET"] = '' ///this.paymentInfo.aliShId;
          postJson["APP_MALL_ID"] = this.paymentInfo.aliMallId;
        }
        if (this.paymentInfo.payWay == "盒子") {
          postJson["APP_ID"] = this.paymentInfo.hzShCode;
          postJson["APP_SECRET"] = "";
          postJson["APP_MALL_ID"] = this.paymentInfo.hzMallCode;
        }
        if (this.paymentInfo.payWay == "东之付") {
          postJson["APP_ID"] = this.paymentInfo.dzfAppId;
          postJson["APP_SECRET"] = this.paymentInfo.dzfAppSecret;
          postJson["APP_MALL_ID"] = this.paymentInfo.dzfMallId;
        }
        if (this.paymentInfo.payWay == "德宏农行付") {
          postJson["APP_ID"] = this.paymentInfo.hdAppId;
          postJson["APP_SECRET"] = this.paymentInfo.hdAppSecret;
          postJson["APP_MALL_ID"] = this.paymentInfo.hdMallId;
        }
        if (this.paymentInfo.payWay == "陕西信合") {
          postJson["APP_ID"] = this.paymentInfo.sxxhShCode;
          postJson["APP_SECRET"] = "";
          postJson["APP_MALL_ID"] = this.paymentInfo.sxxhOfflineCode;
        }
        if (this.paymentInfo.payWay == "银商支付") {
          postJson["APP_ID"] = this.paymentInfo.ysAppId;
          postJson["APP_SECRET"] = this.paymentInfo.ysAppSecret;
          postJson["APP_MALL_ID"] = this.paymentInfo.ysAppMallId;
        }
        if (this.paymentInfo.payWay == "拉卡拉") {
          postJson["APP_ID"] = this.paymentInfo.lklAppId;
          postJson["APP_SECRET"] = this.paymentInfo.lklAppSecret;
          postJson["APP_MALL_ID"] = this.paymentInfo.lklAppMallId;
        }

        if (this.paymentInfo.payWay == "京东支付") {
          postJson["APP_ID"] = this.paymentInfo.jdzfShCode;
          postJson["APP_SECRET"] = this.paymentInfo.jdzfMy;
          postJson["APP_MALL_ID"] = this.paymentInfo.jdzfMallId;
        }
        if (this.paymentInfo.payWay == "河马付") {
          postJson["APP_ID"] = this.paymentInfo.hmAppId;
          postJson["APP_SECRET"] = this.paymentInfo.hmSubAppId;;
          postJson["APP_MALL_ID"] = this.paymentInfo.hmStoreNo;
        }
        if (this.paymentInfo.payWay == "信联付") {
          postJson["APP_ID"] = this.paymentInfo.xlfAppId;
          postJson["APP_SECRET"] = this.paymentInfo.xlfAppSercet;;
          postJson["APP_MALL_ID"] = '';
        }
        if (this.paymentInfo.payWay == "其他支付") {
          postJson["APP_ID"] = this.paymentInfo.qtAppId;
          postJson["APP_SECRET"] = this.paymentInfo.qtAppSecret;;
          postJson["APP_MALL_ID"] = this.paymentInfo.qtMallId;
        }
        console.log(postJson)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('SMSELL_BAND_PAY', postJson);

        return res;
      },

      // 获取商户门店列表信息
      async fBykShMallInfo() {
        let js = {};
        js["OPER"] = "MALL_LIST";
        js["SH_PHONE"] = this.mallDisposeInfo.user_phone;
        // console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },

      // 增加商户门店
      async fBykSellAddMall() {
        let postJson = {};
        postJson["OPER"] = 'MAIN_SRV'
        postJson["ORG_ID"] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        postJson["MCH_ID"] = this.mallDisposeInfo.user_phone;
        postJson["MALL_NAME"] = this.mallInfo.mallName;
        postJson["YEAR_MONEY"] = this.mallInfo.mallAnnualFee;
        postJson["MD_MONEY"] = this.mallInfo.mdMoney;
        postJson["STOP_TIME"] = this.mallInfo.expireTime;

        // console.log(postJson);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('ADD_MCH_MALL', postJson);
        console.log(res.data);
        return res;
      },

      // 修改商户门店信息
      async fBykSellEditMall() {
        let time = new Date(this.mallInfo.expireTime);
        let postJson = {};
        postJson["OPER"] = 'MAIN_SRV'
        postJson["ORG_ID"] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        postJson["MCH_ID"] = this.mallDisposeInfo.user_phone;
        postJson["MALL_ID"] = this.mallInfo.mallId;
        postJson["MALL_NAME"] = this.mallInfo.mallName;
        postJson["YEAR_MONEY"] = this.mallInfo.mallAnnualFee;
        postJson["MD_MONEY"] = this.mallInfo.mdMoney;
        postJson["STOP_TIME"] =
          time.getFullYear() +
          "-" +
          (time.getMonth() - 0 + 1) +
          "-" +
          time.getDate();
        postJson["ZB_XF_YN"] = this.mallInfo.zb_renew ? "Y" : "N";
        // console.log(postJson);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('EDIT_MCH_MALL', postJson);
        // console.log(res.data);
        return res;
      },

      // 清除所有数据
      async fBykSellClearData(oper, time1 = "", time2 = "") {
        let postJson = {};
        postJson["METHOD_NAME"] = "SM_SELL_CLEAR_DATA";
        postJson["SH_PHONE"] = this.mallDisposeInfo.user_phone;
        postJson["OPER"] = oper;
        postJson["START_TIME"] = time1;
        postJson["OVER_TIME"] = time2;
        postJson["PARTNER_PSW"] = this.partnerPwd;

        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('SMSELL_CLEAR_DATA', postJson);
        return res;
      },

      // 重置 1001 密码
      async fBykSellResetPwd() {
        let js = {};
        js["OPER"] = 'RESET_PSW_MAIN';
        js["USER_PHONE"] = this.mallDisposeInfo.user_phone;
        // let res = await this.bykApi.postApi.fPostToBykPlatFormoApi(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        return res;
      },

      // 设置付呗 H5 的支付路径
      async fBykSetFbWxPayPath() {
        let js = {};
        js["USER_SERVER_IP"] = this.shServerIp;
        js["PHONE_NO"] = this.mallDisposeInfo.user_phone;
        js["METHOD_NAME"] = "SET_FB_WX_PAY_PATH";
        js["MALL_ID"] = this.mall_id;
        js["SUB_APP_ID"] = "wxab36abed3127b34a";
        js["JSAPI_PATH"] = "https://www.sanmipos.com/" //"http://www.91byk.com/";
        console.log(js)
        // let res = await this.bykApi.postApi.fPostToByPayApi(js);
        // let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('SET_FB_WX_PAY_PATH', js);
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('SET_FB_WX_PAY_PATH', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone)
        console.log(res)
        console.log(res)
        return res;
      },
      //升级
      async fExecSqlFile() {
        let js = {};
        js['OPER'] = 'smSellDbUpdate'
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('EXEC_SQL_FILE', js, this.shServerUrl, this
          .shServerIp, this.shInfo
          .shPhone)
        console.log(res)
        return res;
      },

      // 子服务器注册信息管理
      // 参数：OPER   USER_PHONE   SOFT_VER    FORCE_UPDATE_YN

      // OPER：
      // win大版本号：WIN_VER
      // 安装大版本号： ANDROID_VER
      // 强制更新值修改： FORCE_UPDATE
      async fSubSrvRegOper(oper) {
        this.$confirm('是否确认推送', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let verNo = oper == 'ANDROID_VER' ? this.mallInfo.androidVer : this.mallInfo.winVer
          if (oper == 'FORCE_UPDATE') {
            verNo = ''
          }
          let res = await this.fSubSrvRegInfo({
            oper: oper,
            ver: verNo,
            forceUpdateYn: this.mallInfo.forceUpdateYn,
          })
          return this.$message(res.msg);
        }).catch(() => {});
      },
      // 门店注册扩展信息
      // 参数：OPER  (客户化设置 SET_CUSTOM   门店调试设置 SET_DEBUG   获取  GET     推送 PUSH)
      async fMchRegEx(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        if (obj.oper == 'SET_DEBUG') {
          // if (this.bykApi.smCom.fSmIsEmpty(this.logSet.logMallId)) {
          //   return this.$message("开启调试门店不能为空");
          // }
          let listJson = {
            // "winPc": "00010001,00010002",
            // "androidPad": "00010001,00010002",
          }
          listJson[this.logSet.logVer] = this.logSet.logMallId
          console.log(listJson)
          js["MALL_LIST"] = JSON.stringify(listJson);

          js["MSG_TYPE"] = this.logSet.logVer
        }

        if (obj.oper == 'PUSH') {
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logMallId)) {
            return this.$message("查看调试日志门店不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logDate)) {
            return this.$message("查看调试日志日期不能为空");
          }
          js["MALL_ID"] = this.logGet.logMallId
          js["MSG_TYPE"] = 'winPcGetLog'
          js["LOG_DAY"] = this.logGet.logDate
        }
        if (obj.oper == 'SET_CUSTOM') {
          if (this.bykApi.smCom.fSmIsEmpty(this.custom.custom_name)) {
            return this.$message("客户名称不能为空");
          }

          js["CUSTOM_YN"] = this.custom.custom_yn || 'N'
          js["CUSTOM_NAME"] = this.custom.custom_name
          js["CUSTOM_URL"] = this.custom.custom_url
          js["CUSTOM_EX"] = this.custom.custom_ex
        }
        if (obj.oper == 'DOWN_LOAD') {
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logMallId)) {
            return this.$message("下载调试日志门店不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logDate)) {
            return this.$message("下载调试日志日期不能为空");
          }
          this.downLoadUrl =
            `https://u.91byk.com/p${this.mallDisposeInfo.user_phone}/Log/${this.mallDisposeInfo.user_phone}_${this.logGet.logMallId}01_${this.logGet.logDate}.zip`
          // window.open(this.downLoadUrl)
          window.location.href = this.downLoadUrl
          //  http://u.91byk.com/p13800000005/Log/13800000005_0001000101_20231018.zip
          return
        }
        //   'http://u.91byk.com/p' + this.mallDisposeInfo.user_phone + '/Log/'+this.mallDisposeInfo.user_phone+'_0001000101_20231018.zip'
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('MCH_REG_EX', js, this.shServerUrl, this.shServerIp,
          this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        if (obj.oper == 'GET' && res.result == 'sucess') {
          return res;
        }
        this.$message(res.msg);
        return res;
      },

      async fSubSrvRegInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["USER_PHONE"] = this.mallDisposeInfo.user_phone
        js["SOFT_VER"] = obj.ver
        js["FORCE_UPDATE_YN"] = obj.forceUpdateYn
        console.log(this.mallDisposeInfo.user_phone);
        console.log(this.shInfo.shPhone);
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('SUB_SRV_REG_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        return res;
      },

      // ---------------------- 请求函数 结束 ------------------------
    },
  };
</script>

<style lang='less' scoped>
  .merchant {
    .header {

      // height: 50px;
      // display: flex;
      // margin-bottom: 8px;
      // margin-right: 20px;
      // justify-content: space-between;
      // align-items: center;
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }

      // /deep/ .buy-software .el-button--warning.is-plain {
      //   border-color: #409eff;
      //   color: #000;
      // }
      // /deep/ .buy-software .el-button--warning.is-plain:hover {
      //   background-color: #409eff;
      //   color: #fff;
      // }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding-right: 40px;
      // height: 600px;
      // overflow-y: scroll;
    }

    .dialog-title {
      line-height: 17px;
      font-size: 14px;
      padding-left: 8px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e6e6e6;
      position: relative;

      &::after {
        content: "";
        display: flex;
        width: 3px;
        height: 14px;
        position: absolute;
        left: 0;
        top: 2px;
        border-left: 3px solid #2c6ff2;
      }
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        color: #606266;
      }
    }

    .centent {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding-bottom: 30px;

      .buy {
        display: flex;
        width: 200px;
        flex-direction: column;
        border: 2px solid #f0f0f0;
        border-radius: 5px;
        overflow: hidden;
        margin-top: 50px;

        .buy-title {
          font-size: 16px;
          font-weight: bold;
          margin: 20px 20px 8px;
        }

        .price {
          font-size: 25px;
          color: #f76062;
          margin: 20px 20px;
        }

        div {
          margin: 5px 20px;
        }
      }

      .buy-active {
        color: #2c6ff2;
        background-color: #f4f8ff;
        border: 2px solid #2c6ff2;

        /deep/ .el-button--default {
          background-color: #2c6ff2;
          color: #fff;
        }
      }
    }

    // 自助注册二维码样式
    .left-line {
      display: flex;
      position: relative;

      &::before {
        content: "";
        display: flex;
        width: 4px;
        height: 20px;
        background-color: #2c6ff2;
        top: 0;
        left: 0;
        margin-right: 10px;
      }
    }

    .must {
      position: relative;

      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    // /deep/ .el-button--default {
    //   border-radius: 0;
    //   border: 0;
    //   background-color: #f0f0f0;
    //   color: #808080;
    //   height: 45px;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/view/cyAdmin.vue